<template>
	<div class="goods-detail">
		
		
		<div data-v-eea730d8="" class="search_bread" style="border-bottom: 1px solid rgb(239 239 244 / 0%); padding: 0px 10px 15px 10px; "><a data-v-eea730d8="" href="/web/" class="router-link-active">หน้าแรก</a><span data-v-eea730d8="" class="padd-10" style=" padding: 0 10px;">&gt;</span>
		
		<router-link :to="{ path: '/list', query: { category_id: c1} }">{{catewords}}</router-link>
			
		
		<span data-v-eea730d8="" class="padd-10" style="padding: 0 10px;" >&gt;</span> <a class="router-link-exact-active router-link-active" style="font-weight: 900; font-family: 'sukhumvittadmai2';     font-weight: 600;" >{{ goodsSkuDetail.sku_name }}</a> <!----><!----></div>
		
		
		<div class="preview-wrap">
			<div class="video-player-wrap" :class="{ show: switchMedia == 'video' }" v-if="goodsSkuDetail.video_url != ''">
				<video-player v-if="goodsSkuDetail.video_url != ''" ref="videoPlayer" :playsinline="true" :options="playerOptions"
				 @play="onPlayerPlay($event)" @pause="onPlayerPause($event)" @ended="onPlayerEnded($event)" @waiting="onPlayerWaiting($event)"
				 @playing="onPlayerPlaying($event)" @loadeddata="onPlayerLoadeddata($event)" @timeupdate="onPlayerTimeupdate($event)"
				 @canplay="onPlayerCanplay($event)" @canplaythrough="onPlayerCanplaythrough($event)" @statechanged="playerStateChanged($event)"
				 @ready="playerReadied"></video-player>

				<div class="media-mode" v-if="goodsSkuDetail.video_url != ''">
					<span :class="{ 'ns-bg-color': switchMedia == 'video' }" @click="switchMedia = 'video'">วีดีโอ</span>
					<span :class="{ 'ns-bg-color': switchMedia == 'img' }" @click="switchMedia = 'img'">ภาพ</span>
				</div>
			</div>
			<div class="magnifier-wrap">
				<pic-zoom ref="PicZoom" :url="$img(picZoomUrl)" :scale="2"></pic-zoom>
			</div>

			<div class="spec-items">
				<span class="left-btn iconfont iconarrow-left-copy" :class="{ move: moveThumbLeft }" @click="changeThumbImg('prev')"></span>
				<span class="right-btn iconfont iconarrow-right" :class="{ move: moveThumbRight }" @click="changeThumbImg('next')"></span>
				<ul :style="{ left: 30 + thumbPosition + 'px' }">
					<!-- รูปขนาดย่อของผลิตภัณฑ์ -->
					<li v-for="(item, index) in goodsSkuDetail.sku_images" :key="index" @mousemove="picZoomUrl = item" :class="{ selected: picZoomUrl == item }">
						<img :src="$img(item, { size: 'small' })" @error="imageErrorSpec(index)" />
					</li>
				</ul>
			</div>
			<div class="share-collect">
				<div @click="editCollection">
					<i class="iconfont" :class="whetherCollection == 1 ? 'iconlikefill ns-text-color' : 'iconlike'"></i>
					<span data-collects="0">มุ่งเน้นไปที่ผลิตภัณฑ์（{{ goodsSkuDetail.collect_num }}）</span>
				</div>
				<div v-if="kefuConfig.system == 0 && kefuConfig.open_pc == 1">
					<i class="iconfont iconzhanghao"></i>
					<span data-collects="0"><a :href="kefuConfig.open_url" target="_blank">ติดต่อฝ่ายบริการลูกค้า</a></span>
				</div>
				<div @click="service_link" v-else-if="kefuConfig.system == 1">
					<i class="iconfont iconzhanghao"></i>
					<span data-collects="0">ติดต่อฝ่ายบริการลูกค้า</span>
				</div>
			</div>
		</div>
















		<!-- ข้อมูลผลิตภัณฑ์ -->
		<div class="basic-info-wrap" v-loading="loading">
			
			
			
			<h1 style="       font-size: 23px;
    font-family: 'sukhumvittadmai2'; " >{{ goodsSkuDetail.sku_name }}</h1>
	

			
			<div style="margin-top: 10px;">
				<div class="hO9GFq">
				<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="204" zoomAndPan="magnify" viewBox="0 0 153 30.000001" height="40" preserveAspectRatio="xMidYMid meet" version="1.0" style="width: 127px;"><defs><g/></defs><g fill="#724d45" fill-opacity="0.1608"><g transform="translate(13.235085, 27.352241)"><g><path d="M 5.046875 -5.359375 C 5.046875 -5.066406 5.117188 -4.816406 5.265625 -4.609375 C 5.410156 -4.410156 5.59375 -4.253906 5.8125 -4.140625 C 6.039062 -4.023438 6.296875 -3.941406 6.578125 -3.890625 C 6.859375 -3.835938 7.132812 -3.8125 7.40625 -3.8125 C 7.925781 -3.8125 8.367188 -3.859375 8.734375 -3.953125 C 9.109375 -4.054688 9.484375 -4.1875 9.859375 -4.34375 L 9.859375 -15.125 C 9.859375 -15.414062 9.929688 -15.679688 10.078125 -15.921875 C 10.222656 -16.171875 10.421875 -16.378906 10.671875 -16.546875 C 10.921875 -16.710938 11.195312 -16.84375 11.5 -16.9375 C 11.800781 -17.03125 12.109375 -17.078125 12.421875 -17.078125 C 12.867188 -17.078125 13.253906 -16.953125 13.578125 -16.703125 C 13.910156 -16.453125 14.078125 -16.054688 14.078125 -15.515625 L 14.078125 -4.75 C 14.078125 -3.9375 13.867188 -3.21875 13.453125 -2.59375 C 13.035156 -1.96875 12.5 -1.445312 11.84375 -1.03125 C 11.195312 -0.613281 10.472656 -0.296875 9.671875 -0.078125 C 8.878906 0.128906 8.101562 0.234375 7.34375 0.234375 C 6.550781 0.234375 5.769531 0.117188 5 -0.109375 C 4.226562 -0.347656 3.53125 -0.703125 2.90625 -1.171875 C 2.289062 -1.648438 1.789062 -2.226562 1.40625 -2.90625 C 1.03125 -3.59375 0.84375 -4.382812 0.84375 -5.28125 L 0.84375 -7.140625 C 0.84375 -7.515625 0.859375 -7.832031 0.890625 -8.09375 C 0.921875 -8.351562 0.972656 -8.585938 1.046875 -8.796875 C 1.128906 -9.015625 1.25 -9.222656 1.40625 -9.421875 C 1.570312 -9.628906 1.773438 -9.851562 2.015625 -10.09375 L 3.125 -11.21875 C 3.3125 -11.394531 3.425781 -11.550781 3.46875 -11.6875 C 3.507812 -11.820312 3.53125 -12.007812 3.53125 -12.25 L 3.53125 -12.453125 C 3.53125 -12.679688 3.421875 -12.796875 3.203125 -12.796875 L 2.359375 -12.796875 C 1.796875 -12.796875 1.382812 -12.957031 1.125 -13.28125 C 0.863281 -13.601562 0.734375 -13.988281 0.734375 -14.4375 C 0.734375 -14.707031 0.785156 -14.988281 0.890625 -15.28125 C 0.992188 -15.570312 1.132812 -15.828125 1.3125 -16.046875 C 1.488281 -16.273438 1.703125 -16.460938 1.953125 -16.609375 C 2.203125 -16.753906 2.484375 -16.828125 2.796875 -16.828125 L 3.296875 -16.828125 C 4.015625 -16.828125 4.648438 -16.710938 5.203125 -16.484375 C 5.753906 -16.265625 6.210938 -15.960938 6.578125 -15.578125 C 6.953125 -15.203125 7.238281 -14.757812 7.4375 -14.25 C 7.644531 -13.75 7.75 -13.21875 7.75 -12.65625 L 7.75 -12.125 C 7.75 -11.757812 7.726562 -11.425781 7.6875 -11.125 C 7.65625 -10.820312 7.59375 -10.539062 7.5 -10.28125 C 7.414062 -10.03125 7.296875 -9.78125 7.140625 -9.53125 C 6.984375 -9.28125 6.78125 -9.03125 6.53125 -8.78125 L 5.453125 -7.703125 C 5.296875 -7.546875 5.1875 -7.398438 5.125 -7.265625 C 5.070312 -7.140625 5.046875 -6.953125 5.046875 -6.703125 Z M 5.046875 -5.359375 "/></g></g></g><g fill="#724d45" fill-opacity="0.1608"><g transform="translate(28.31638, 27.352241)"><g><path d="M 10.4375 -1.71875 C 10.4375 -1.425781 10.359375 -1.15625 10.203125 -0.90625 C 10.046875 -0.65625 9.847656 -0.445312 9.609375 -0.28125 C 9.378906 -0.113281 9.109375 0.0078125 8.796875 0.09375 C 8.492188 0.1875 8.195312 0.234375 7.90625 0.234375 C 7.457031 0.234375 7.066406 0.113281 6.734375 -0.125 C 6.398438 -0.375 6.234375 -0.769531 6.234375 -1.3125 L 6.234375 -11.046875 C 6.234375 -12.367188 5.503906 -13.03125 4.046875 -13.03125 C 3.640625 -13.03125 3.257812 -13 2.90625 -12.9375 C 2.5625 -12.882812 2.265625 -12.859375 2.015625 -12.859375 C 1.484375 -12.859375 1.078125 -13.066406 0.796875 -13.484375 C 0.515625 -13.898438 0.375 -14.390625 0.375 -14.953125 C 0.375 -15.421875 0.46875 -15.820312 0.65625 -16.15625 C 0.84375 -16.5 1.148438 -16.722656 1.578125 -16.828125 C 2.023438 -16.941406 2.484375 -17.007812 2.953125 -17.03125 C 3.429688 -17.0625 3.894531 -17.078125 4.34375 -17.078125 C 6.25 -17.078125 7.738281 -16.617188 8.8125 -15.703125 C 9.894531 -14.796875 10.4375 -13.332031 10.4375 -11.3125 Z M 10.4375 -1.71875 "/></g></g></g><g fill="#724d45" fill-opacity="0.1608"><g transform="translate(39.762007, 27.352241)"><g><path d="M 5.6875 -7.109375 C 5.351562 -7.109375 5.113281 -6.976562 4.96875 -6.71875 C 4.820312 -6.457031 4.75 -6.148438 4.75 -5.796875 C 4.75 -5.429688 4.832031 -5.117188 5 -4.859375 C 5.164062 -4.609375 5.394531 -4.398438 5.6875 -4.234375 C 5.976562 -4.078125 6.300781 -3.96875 6.65625 -3.90625 C 7.019531 -3.84375 7.382812 -3.8125 7.75 -3.8125 C 8.332031 -3.8125 8.875 -3.875 9.375 -4 C 9.882812 -4.132812 10.328125 -4.296875 10.703125 -4.484375 L 10.703125 -15.125 C 10.703125 -15.382812 10.78125 -15.640625 10.9375 -15.890625 C 11.09375 -16.140625 11.289062 -16.347656 11.53125 -16.515625 C 11.769531 -16.679688 12.046875 -16.816406 12.359375 -16.921875 C 12.671875 -17.023438 12.972656 -17.078125 13.265625 -17.078125 C 13.734375 -17.078125 14.125 -16.953125 14.4375 -16.703125 C 14.757812 -16.453125 14.921875 -16.054688 14.921875 -15.515625 L 14.921875 -5.3125 C 14.921875 -4.414062 14.71875 -3.617188 14.3125 -2.921875 C 13.90625 -2.234375 13.363281 -1.648438 12.6875 -1.171875 C 12.019531 -0.703125 11.253906 -0.347656 10.390625 -0.109375 C 9.523438 0.117188 8.644531 0.234375 7.75 0.234375 C 6.71875 0.234375 5.773438 0.0859375 4.921875 -0.203125 C 4.066406 -0.492188 3.320312 -0.890625 2.6875 -1.390625 C 2.0625 -1.898438 1.570312 -2.488281 1.21875 -3.15625 C 0.875 -3.832031 0.703125 -4.550781 0.703125 -5.3125 C 0.703125 -5.96875 0.835938 -6.625 1.109375 -7.28125 C 1.378906 -7.945312 1.816406 -8.617188 2.421875 -9.296875 C 2.046875 -9.742188 1.722656 -10.234375 1.453125 -10.765625 C 1.179688 -11.304688 1.046875 -11.867188 1.046875 -12.453125 C 1.046875 -13.015625 1.132812 -13.5625 1.3125 -14.09375 C 1.488281 -14.625 1.753906 -15.085938 2.109375 -15.484375 C 2.472656 -15.890625 2.929688 -16.210938 3.484375 -16.453125 C 4.035156 -16.703125 4.671875 -16.828125 5.390625 -16.828125 L 7 -16.828125 C 7.539062 -16.828125 7.929688 -16.660156 8.171875 -16.328125 C 8.421875 -15.992188 8.546875 -15.601562 8.546875 -15.15625 C 8.546875 -14.59375 8.375 -14.054688 8.03125 -13.546875 C 7.6875 -13.046875 7.195312 -12.796875 6.5625 -12.796875 L 5.65625 -12.796875 C 5.457031 -12.796875 5.3125 -12.703125 5.21875 -12.515625 C 5.125 -12.335938 5.078125 -12.148438 5.078125 -11.953125 C 5.078125 -11.753906 5.125 -11.566406 5.21875 -11.390625 C 5.3125 -11.222656 5.457031 -11.140625 5.65625 -11.140625 L 7.265625 -11.140625 C 7.804688 -11.140625 8.203125 -10.972656 8.453125 -10.640625 C 8.703125 -10.304688 8.828125 -9.914062 8.828125 -9.46875 C 8.828125 -8.90625 8.664062 -8.367188 8.34375 -7.859375 C 8.03125 -7.359375 7.5625 -7.109375 6.9375 -7.109375 Z M 5.6875 -7.109375 "/></g></g></g><g fill="#724d45" fill-opacity="0.1608"><g transform="translate(55.68489, 27.352241)"><g><path d="M 5.6875 -7.109375 C 5.351562 -7.109375 5.113281 -6.976562 4.96875 -6.71875 C 4.820312 -6.457031 4.75 -6.148438 4.75 -5.796875 C 4.75 -5.429688 4.832031 -5.117188 5 -4.859375 C 5.164062 -4.609375 5.394531 -4.398438 5.6875 -4.234375 C 5.976562 -4.078125 6.300781 -3.96875 6.65625 -3.90625 C 7.019531 -3.84375 7.382812 -3.8125 7.75 -3.8125 C 8.332031 -3.8125 8.875 -3.875 9.375 -4 C 9.882812 -4.132812 10.328125 -4.296875 10.703125 -4.484375 L 10.703125 -15.125 C 10.703125 -15.382812 10.78125 -15.640625 10.9375 -15.890625 C 11.09375 -16.140625 11.289062 -16.347656 11.53125 -16.515625 C 11.769531 -16.679688 12.046875 -16.816406 12.359375 -16.921875 C 12.671875 -17.023438 12.972656 -17.078125 13.265625 -17.078125 C 13.734375 -17.078125 14.125 -16.953125 14.4375 -16.703125 C 14.757812 -16.453125 14.921875 -16.054688 14.921875 -15.515625 L 14.921875 -5.3125 C 14.921875 -4.414062 14.71875 -3.617188 14.3125 -2.921875 C 13.90625 -2.234375 13.363281 -1.648438 12.6875 -1.171875 C 12.019531 -0.703125 11.253906 -0.347656 10.390625 -0.109375 C 9.523438 0.117188 8.644531 0.234375 7.75 0.234375 C 6.71875 0.234375 5.773438 0.0859375 4.921875 -0.203125 C 4.066406 -0.492188 3.320312 -0.890625 2.6875 -1.390625 C 2.0625 -1.898438 1.570312 -2.488281 1.21875 -3.15625 C 0.875 -3.832031 0.703125 -4.550781 0.703125 -5.3125 C 0.703125 -5.96875 0.835938 -6.625 1.109375 -7.28125 C 1.378906 -7.945312 1.816406 -8.617188 2.421875 -9.296875 C 2.046875 -9.742188 1.722656 -10.234375 1.453125 -10.765625 C 1.179688 -11.304688 1.046875 -11.867188 1.046875 -12.453125 C 1.046875 -13.015625 1.132812 -13.5625 1.3125 -14.09375 C 1.488281 -14.625 1.753906 -15.085938 2.109375 -15.484375 C 2.472656 -15.890625 2.929688 -16.210938 3.484375 -16.453125 C 4.035156 -16.703125 4.671875 -16.828125 5.390625 -16.828125 L 7 -16.828125 C 7.539062 -16.828125 7.929688 -16.660156 8.171875 -16.328125 C 8.421875 -15.992188 8.546875 -15.601562 8.546875 -15.15625 C 8.546875 -14.59375 8.375 -14.054688 8.03125 -13.546875 C 7.6875 -13.046875 7.195312 -12.796875 6.5625 -12.796875 L 5.65625 -12.796875 C 5.457031 -12.796875 5.3125 -12.703125 5.21875 -12.515625 C 5.125 -12.335938 5.078125 -12.148438 5.078125 -11.953125 C 5.078125 -11.753906 5.125 -11.566406 5.21875 -11.390625 C 5.3125 -11.222656 5.457031 -11.140625 5.65625 -11.140625 L 7.265625 -11.140625 C 7.804688 -11.140625 8.203125 -10.972656 8.453125 -10.640625 C 8.703125 -10.304688 8.828125 -9.914062 8.828125 -9.46875 C 8.828125 -8.90625 8.664062 -8.367188 8.34375 -7.859375 C 8.03125 -7.359375 7.5625 -7.109375 6.9375 -7.109375 Z M 5.6875 -7.109375 "/></g></g></g><g fill="#724d45" fill-opacity="0.1608"><g transform="translate(71.607776, 27.352241)"><g><path d="M 14.953125 -1.71875 C 14.953125 -1.425781 14.875 -1.15625 14.71875 -0.90625 C 14.5625 -0.65625 14.363281 -0.445312 14.125 -0.28125 C 13.882812 -0.113281 13.613281 0.0078125 13.3125 0.09375 C 13.007812 0.1875 12.710938 0.234375 12.421875 0.234375 C 11.972656 0.234375 11.578125 0.113281 11.234375 -0.125 C 10.898438 -0.375 10.734375 -0.769531 10.734375 -1.3125 L 10.734375 -10.84375 C 10.734375 -11.25 10.65625 -11.59375 10.5 -11.875 C 10.34375 -12.15625 10.132812 -12.378906 9.875 -12.546875 C 9.625 -12.710938 9.328125 -12.832031 8.984375 -12.90625 C 8.648438 -12.988281 8.304688 -13.03125 7.953125 -13.03125 C 7.390625 -13.03125 6.835938 -12.96875 6.296875 -12.84375 C 5.753906 -12.71875 5.304688 -12.566406 4.953125 -12.390625 L 5.21875 -10.640625 L 5.21875 -1.71875 C 5.21875 -1.425781 5.140625 -1.15625 4.984375 -0.90625 C 4.828125 -0.65625 4.628906 -0.445312 4.390625 -0.28125 C 4.160156 -0.113281 3.890625 0.0078125 3.578125 0.09375 C 3.273438 0.1875 2.976562 0.234375 2.6875 0.234375 C 2.238281 0.234375 1.847656 0.113281 1.515625 -0.125 C 1.179688 -0.375 1.015625 -0.769531 1.015625 -1.3125 L 1.015625 -7.8125 C 1.015625 -8.351562 1.054688 -8.894531 1.140625 -9.4375 C 1.234375 -9.988281 1.367188 -10.503906 1.546875 -10.984375 C 1.328125 -11.398438 1.128906 -11.898438 0.953125 -12.484375 C 0.785156 -13.078125 0.660156 -13.742188 0.578125 -14.484375 C 1.742188 -15.171875 2.957031 -15.773438 4.21875 -16.296875 C 5.488281 -16.816406 6.765625 -17.078125 8.046875 -17.078125 C 8.859375 -17.078125 9.671875 -16.957031 10.484375 -16.71875 C 11.304688 -16.476562 12.046875 -16.117188 12.703125 -15.640625 C 13.367188 -15.160156 13.910156 -14.546875 14.328125 -13.796875 C 14.742188 -13.054688 14.953125 -12.171875 14.953125 -11.140625 Z M 14.953125 -1.71875 "/></g></g></g><g fill="#724d45" fill-opacity="0.1608"><g transform="translate(87.564323, 27.352241)"><g><path d="M 5.21875 -4.046875 L 5.453125 -4.046875 C 6.054688 -4.046875 6.523438 -3.804688 6.859375 -3.328125 C 7.203125 -2.859375 7.375 -2.34375 7.375 -1.78125 C 7.375 -1.3125 7.242188 -0.894531 6.984375 -0.53125 C 6.722656 -0.175781 6.300781 0 5.71875 0 L 4.875 0 C 3.46875 0 2.472656 -0.328125 1.890625 -0.984375 C 1.304688 -1.648438 1.015625 -2.601562 1.015625 -3.84375 L 1.015625 -15.125 C 1.015625 -15.414062 1.085938 -15.679688 1.234375 -15.921875 C 1.378906 -16.171875 1.570312 -16.378906 1.8125 -16.546875 C 2.0625 -16.710938 2.335938 -16.84375 2.640625 -16.9375 C 2.941406 -17.03125 3.25 -17.078125 3.5625 -17.078125 C 4.019531 -17.078125 4.410156 -16.953125 4.734375 -16.703125 C 5.054688 -16.453125 5.21875 -16.054688 5.21875 -15.515625 Z M 12.296875 -4.046875 L 12.53125 -4.046875 C 13.132812 -4.046875 13.601562 -3.804688 13.9375 -3.328125 C 14.269531 -2.859375 14.4375 -2.34375 14.4375 -1.78125 C 14.4375 -1.3125 14.304688 -0.894531 14.046875 -0.53125 C 13.796875 -0.175781 13.378906 0 12.796875 0 L 11.953125 0 C 10.535156 0 9.535156 -0.328125 8.953125 -0.984375 C 8.367188 -1.648438 8.078125 -2.601562 8.078125 -3.84375 L 8.078125 -15.125 C 8.078125 -15.414062 8.148438 -15.679688 8.296875 -15.921875 C 8.441406 -16.171875 8.640625 -16.378906 8.890625 -16.546875 C 9.140625 -16.710938 9.414062 -16.84375 9.71875 -16.9375 C 10.019531 -17.03125 10.328125 -17.078125 10.640625 -17.078125 C 11.085938 -17.078125 11.472656 -16.953125 11.796875 -16.703125 C 12.128906 -16.453125 12.296875 -16.054688 12.296875 -15.515625 Z M 12.296875 -4.046875 "/></g></g></g><g fill="#724d45" fill-opacity="0.1608"><g transform="translate(102.006012, 27.352241)"><g><path d="M 12.09375 -14.40625 L 14.4375 -6.03125 L 16.0625 -15.359375 C 16.101562 -15.628906 16.21875 -15.863281 16.40625 -16.0625 C 16.601562 -16.257812 16.835938 -16.4375 17.109375 -16.59375 C 17.378906 -16.75 17.671875 -16.867188 17.984375 -16.953125 C 18.296875 -17.035156 18.597656 -17.078125 18.890625 -17.078125 C 19.472656 -17.078125 19.910156 -16.914062 20.203125 -16.59375 C 20.492188 -16.28125 20.5625 -15.800781 20.40625 -15.15625 L 17.078125 -1.75 C 16.890625 -1.070312 16.515625 -0.570312 15.953125 -0.25 C 15.398438 0.0703125 14.796875 0.234375 14.140625 0.234375 C 13.691406 0.234375 13.269531 0.125 12.875 -0.09375 C 12.488281 -0.320312 12.226562 -0.695312 12.09375 -1.21875 L 10.4375 -7.609375 L 9.03125 -1.6875 C 8.894531 -1.101562 8.535156 -0.632812 7.953125 -0.28125 C 7.367188 0.0625 6.75 0.234375 6.09375 0.234375 C 5.53125 0.234375 5.054688 0.117188 4.671875 -0.109375 C 4.296875 -0.347656 4.050781 -0.71875 3.9375 -1.21875 L 0.609375 -14.71875 C 0.453125 -15.34375 0.554688 -15.890625 0.921875 -16.359375 C 1.296875 -16.835938 1.832031 -17.078125 2.53125 -17.078125 C 3.0625 -17.078125 3.539062 -16.96875 3.96875 -16.75 C 4.394531 -16.539062 4.65625 -16.210938 4.75 -15.765625 L 6.390625 -6.03125 L 7.953125 -15.328125 C 8.054688 -15.878906 8.382812 -16.304688 8.9375 -16.609375 C 9.488281 -16.921875 10.085938 -17.078125 10.734375 -17.078125 C 11.390625 -17.078125 11.859375 -16.914062 12.140625 -16.59375 C 12.421875 -16.28125 12.472656 -15.8125 12.296875 -15.1875 Z M 12.09375 -14.40625 "/></g></g></g><g fill="#724d45" fill-opacity="0.1608"><g transform="translate(123.045771, 27.352241)"><g><path d="M -5.390625 -18.625 C -5.953125 -18.625 -6.429688 -18.742188 -6.828125 -18.984375 C -7.234375 -19.234375 -7.5625 -19.550781 -7.8125 -19.9375 L -7.8125 -19.59375 C -7.8125 -19.238281 -7.925781 -18.96875 -8.15625 -18.78125 C -8.394531 -18.601562 -8.6875 -18.515625 -9.03125 -18.515625 C -9.675781 -18.515625 -10.25 -18.769531 -10.75 -19.28125 C -11.257812 -19.800781 -11.515625 -20.59375 -11.515625 -21.65625 C -11.515625 -22.101562 -11.453125 -22.5625 -11.328125 -23.03125 C -11.203125 -23.5 -11.015625 -23.925781 -10.765625 -24.3125 C -10.523438 -24.695312 -10.207031 -25.003906 -9.8125 -25.234375 C -9.414062 -25.472656 -8.953125 -25.59375 -8.421875 -25.59375 L -2.59375 -25.59375 C -2.144531 -25.59375 -1.789062 -25.382812 -1.53125 -24.96875 C -1.269531 -24.550781 -1.140625 -24.117188 -1.140625 -23.671875 C -1.140625 -23.359375 -1.21875 -23.078125 -1.375 -22.828125 C -1.53125 -22.578125 -1.789062 -22.453125 -2.15625 -22.453125 L -7.8125 -22.453125 C -7.269531 -21.984375 -6.617188 -21.75 -5.859375 -21.75 L -3.734375 -21.75 C -3.359375 -21.75 -3.082031 -21.617188 -2.90625 -21.359375 C -2.738281 -21.109375 -2.65625 -20.8125 -2.65625 -20.46875 C -2.65625 -20.019531 -2.785156 -19.597656 -3.046875 -19.203125 C -3.304688 -18.816406 -3.679688 -18.625 -4.171875 -18.625 Z M -5.390625 -18.625 "/></g></g></g><g fill="#724d45" fill-opacity="0.1608"><g transform="translate(123.045771, 27.352241)"><g><path d="M 10.84375 -10.8125 C 10.84375 -11.164062 10.75 -11.484375 10.5625 -11.765625 C 10.382812 -12.046875 10.144531 -12.273438 9.84375 -12.453125 C 9.539062 -12.640625 9.207031 -12.78125 8.84375 -12.875 C 8.488281 -12.976562 8.125 -13.03125 7.75 -13.03125 C 6.976562 -13.03125 6.296875 -12.820312 5.703125 -12.40625 C 5.109375 -11.988281 4.8125 -11.332031 4.8125 -10.4375 C 4.8125 -10.320312 4.816406 -10.179688 4.828125 -10.015625 C 4.835938 -9.847656 4.867188 -9.695312 4.921875 -9.5625 C 5.179688 -9.757812 5.441406 -9.894531 5.703125 -9.96875 C 5.960938 -10.050781 6.316406 -10.09375 6.765625 -10.09375 L 8.453125 -10.09375 C 8.941406 -10.09375 9.316406 -9.925781 9.578125 -9.59375 C 9.835938 -9.257812 9.96875 -8.832031 9.96875 -8.3125 C 9.96875 -7.664062 9.796875 -7.128906 9.453125 -6.703125 C 9.117188 -6.273438 8.5625 -6.0625 7.78125 -6.0625 L 7.234375 -6.0625 C 6.898438 -6.0625 6.660156 -5.992188 6.515625 -5.859375 C 6.367188 -5.722656 6.265625 -5.5 6.203125 -5.1875 L 5.390625 -1.28125 C 5.316406 -1.007812 5.191406 -0.773438 5.015625 -0.578125 C 4.835938 -0.390625 4.613281 -0.234375 4.34375 -0.109375 C 4.070312 0.00390625 3.78125 0.0859375 3.46875 0.140625 C 3.15625 0.203125 2.84375 0.234375 2.53125 0.234375 C 1.894531 0.234375 1.429688 0.117188 1.140625 -0.109375 C 0.847656 -0.347656 0.78125 -0.769531 0.9375 -1.375 L 2.1875 -6.5625 C 1.695312 -7.238281 1.3125 -7.945312 1.03125 -8.6875 C 0.75 -9.425781 0.609375 -10.15625 0.609375 -10.875 C 0.609375 -11.90625 0.804688 -12.804688 1.203125 -13.578125 C 1.609375 -14.359375 2.148438 -15.003906 2.828125 -15.515625 C 3.503906 -16.035156 4.265625 -16.425781 5.109375 -16.6875 C 5.960938 -16.945312 6.84375 -17.078125 7.75 -17.078125 C 8.644531 -17.078125 9.53125 -16.945312 10.40625 -16.6875 C 11.28125 -16.425781 12.054688 -16.039062 12.734375 -15.53125 C 13.421875 -15.03125 13.976562 -14.398438 14.40625 -13.640625 C 14.832031 -12.878906 15.046875 -11.992188 15.046875 -10.984375 L 15.046875 -1.71875 C 15.046875 -1.425781 14.96875 -1.15625 14.8125 -0.90625 C 14.65625 -0.65625 14.457031 -0.445312 14.21875 -0.28125 C 13.988281 -0.113281 13.722656 0.0078125 13.421875 0.09375 C 13.117188 0.1875 12.820312 0.234375 12.53125 0.234375 C 12.082031 0.234375 11.6875 0.113281 11.34375 -0.125 C 11.007812 -0.375 10.84375 -0.769531 10.84375 -1.3125 Z M 10.84375 -10.8125 "/></g></g></g><g fill="#ffffff" fill-opacity="1"><g transform="translate(11.968777, 25.671794)"><g><path d="M 5.046875 -5.359375 C 5.046875 -5.066406 5.117188 -4.816406 5.265625 -4.609375 C 5.410156 -4.410156 5.59375 -4.253906 5.8125 -4.140625 C 6.039062 -4.023438 6.296875 -3.941406 6.578125 -3.890625 C 6.859375 -3.835938 7.132812 -3.8125 7.40625 -3.8125 C 7.925781 -3.8125 8.367188 -3.859375 8.734375 -3.953125 C 9.109375 -4.054688 9.484375 -4.1875 9.859375 -4.34375 L 9.859375 -15.125 C 9.859375 -15.414062 9.929688 -15.679688 10.078125 -15.921875 C 10.222656 -16.171875 10.421875 -16.378906 10.671875 -16.546875 C 10.921875 -16.710938 11.195312 -16.84375 11.5 -16.9375 C 11.800781 -17.03125 12.109375 -17.078125 12.421875 -17.078125 C 12.867188 -17.078125 13.253906 -16.953125 13.578125 -16.703125 C 13.910156 -16.453125 14.078125 -16.054688 14.078125 -15.515625 L 14.078125 -4.75 C 14.078125 -3.9375 13.867188 -3.21875 13.453125 -2.59375 C 13.035156 -1.96875 12.5 -1.445312 11.84375 -1.03125 C 11.195312 -0.613281 10.472656 -0.296875 9.671875 -0.078125 C 8.878906 0.128906 8.101562 0.234375 7.34375 0.234375 C 6.550781 0.234375 5.769531 0.117188 5 -0.109375 C 4.226562 -0.347656 3.53125 -0.703125 2.90625 -1.171875 C 2.289062 -1.648438 1.789062 -2.226562 1.40625 -2.90625 C 1.03125 -3.59375 0.84375 -4.382812 0.84375 -5.28125 L 0.84375 -7.140625 C 0.84375 -7.515625 0.859375 -7.832031 0.890625 -8.09375 C 0.921875 -8.351562 0.972656 -8.585938 1.046875 -8.796875 C 1.128906 -9.015625 1.25 -9.222656 1.40625 -9.421875 C 1.570312 -9.628906 1.773438 -9.851562 2.015625 -10.09375 L 3.125 -11.21875 C 3.3125 -11.394531 3.425781 -11.550781 3.46875 -11.6875 C 3.507812 -11.820312 3.53125 -12.007812 3.53125 -12.25 L 3.53125 -12.453125 C 3.53125 -12.679688 3.421875 -12.796875 3.203125 -12.796875 L 2.359375 -12.796875 C 1.796875 -12.796875 1.382812 -12.957031 1.125 -13.28125 C 0.863281 -13.601562 0.734375 -13.988281 0.734375 -14.4375 C 0.734375 -14.707031 0.785156 -14.988281 0.890625 -15.28125 C 0.992188 -15.570312 1.132812 -15.828125 1.3125 -16.046875 C 1.488281 -16.273438 1.703125 -16.460938 1.953125 -16.609375 C 2.203125 -16.753906 2.484375 -16.828125 2.796875 -16.828125 L 3.296875 -16.828125 C 4.015625 -16.828125 4.648438 -16.710938 5.203125 -16.484375 C 5.753906 -16.265625 6.210938 -15.960938 6.578125 -15.578125 C 6.953125 -15.203125 7.238281 -14.757812 7.4375 -14.25 C 7.644531 -13.75 7.75 -13.21875 7.75 -12.65625 L 7.75 -12.125 C 7.75 -11.757812 7.726562 -11.425781 7.6875 -11.125 C 7.65625 -10.820312 7.59375 -10.539062 7.5 -10.28125 C 7.414062 -10.03125 7.296875 -9.78125 7.140625 -9.53125 C 6.984375 -9.28125 6.78125 -9.03125 6.53125 -8.78125 L 5.453125 -7.703125 C 5.296875 -7.546875 5.1875 -7.398438 5.125 -7.265625 C 5.070312 -7.140625 5.046875 -6.953125 5.046875 -6.703125 Z M 5.046875 -5.359375 "/></g></g></g><g fill="#ffffff" fill-opacity="1"><g transform="translate(27.050072, 25.671794)"><g><path d="M 10.4375 -1.71875 C 10.4375 -1.425781 10.359375 -1.15625 10.203125 -0.90625 C 10.046875 -0.65625 9.847656 -0.445312 9.609375 -0.28125 C 9.378906 -0.113281 9.109375 0.0078125 8.796875 0.09375 C 8.492188 0.1875 8.195312 0.234375 7.90625 0.234375 C 7.457031 0.234375 7.066406 0.113281 6.734375 -0.125 C 6.398438 -0.375 6.234375 -0.769531 6.234375 -1.3125 L 6.234375 -11.046875 C 6.234375 -12.367188 5.503906 -13.03125 4.046875 -13.03125 C 3.640625 -13.03125 3.257812 -13 2.90625 -12.9375 C 2.5625 -12.882812 2.265625 -12.859375 2.015625 -12.859375 C 1.484375 -12.859375 1.078125 -13.066406 0.796875 -13.484375 C 0.515625 -13.898438 0.375 -14.390625 0.375 -14.953125 C 0.375 -15.421875 0.46875 -15.820312 0.65625 -16.15625 C 0.84375 -16.5 1.148438 -16.722656 1.578125 -16.828125 C 2.023438 -16.941406 2.484375 -17.007812 2.953125 -17.03125 C 3.429688 -17.0625 3.894531 -17.078125 4.34375 -17.078125 C 6.25 -17.078125 7.738281 -16.617188 8.8125 -15.703125 C 9.894531 -14.796875 10.4375 -13.332031 10.4375 -11.3125 Z M 10.4375 -1.71875 "/></g></g></g><g fill="#ffffff" fill-opacity="1"><g transform="translate(38.495699, 25.671794)"><g><path d="M 5.6875 -7.109375 C 5.351562 -7.109375 5.113281 -6.976562 4.96875 -6.71875 C 4.820312 -6.457031 4.75 -6.148438 4.75 -5.796875 C 4.75 -5.429688 4.832031 -5.117188 5 -4.859375 C 5.164062 -4.609375 5.394531 -4.398438 5.6875 -4.234375 C 5.976562 -4.078125 6.300781 -3.96875 6.65625 -3.90625 C 7.019531 -3.84375 7.382812 -3.8125 7.75 -3.8125 C 8.332031 -3.8125 8.875 -3.875 9.375 -4 C 9.882812 -4.132812 10.328125 -4.296875 10.703125 -4.484375 L 10.703125 -15.125 C 10.703125 -15.382812 10.78125 -15.640625 10.9375 -15.890625 C 11.09375 -16.140625 11.289062 -16.347656 11.53125 -16.515625 C 11.769531 -16.679688 12.046875 -16.816406 12.359375 -16.921875 C 12.671875 -17.023438 12.972656 -17.078125 13.265625 -17.078125 C 13.734375 -17.078125 14.125 -16.953125 14.4375 -16.703125 C 14.757812 -16.453125 14.921875 -16.054688 14.921875 -15.515625 L 14.921875 -5.3125 C 14.921875 -4.414062 14.71875 -3.617188 14.3125 -2.921875 C 13.90625 -2.234375 13.363281 -1.648438 12.6875 -1.171875 C 12.019531 -0.703125 11.253906 -0.347656 10.390625 -0.109375 C 9.523438 0.117188 8.644531 0.234375 7.75 0.234375 C 6.71875 0.234375 5.773438 0.0859375 4.921875 -0.203125 C 4.066406 -0.492188 3.320312 -0.890625 2.6875 -1.390625 C 2.0625 -1.898438 1.570312 -2.488281 1.21875 -3.15625 C 0.875 -3.832031 0.703125 -4.550781 0.703125 -5.3125 C 0.703125 -5.96875 0.835938 -6.625 1.109375 -7.28125 C 1.378906 -7.945312 1.816406 -8.617188 2.421875 -9.296875 C 2.046875 -9.742188 1.722656 -10.234375 1.453125 -10.765625 C 1.179688 -11.304688 1.046875 -11.867188 1.046875 -12.453125 C 1.046875 -13.015625 1.132812 -13.5625 1.3125 -14.09375 C 1.488281 -14.625 1.753906 -15.085938 2.109375 -15.484375 C 2.472656 -15.890625 2.929688 -16.210938 3.484375 -16.453125 C 4.035156 -16.703125 4.671875 -16.828125 5.390625 -16.828125 L 7 -16.828125 C 7.539062 -16.828125 7.929688 -16.660156 8.171875 -16.328125 C 8.421875 -15.992188 8.546875 -15.601562 8.546875 -15.15625 C 8.546875 -14.59375 8.375 -14.054688 8.03125 -13.546875 C 7.6875 -13.046875 7.195312 -12.796875 6.5625 -12.796875 L 5.65625 -12.796875 C 5.457031 -12.796875 5.3125 -12.703125 5.21875 -12.515625 C 5.125 -12.335938 5.078125 -12.148438 5.078125 -11.953125 C 5.078125 -11.753906 5.125 -11.566406 5.21875 -11.390625 C 5.3125 -11.222656 5.457031 -11.140625 5.65625 -11.140625 L 7.265625 -11.140625 C 7.804688 -11.140625 8.203125 -10.972656 8.453125 -10.640625 C 8.703125 -10.304688 8.828125 -9.914062 8.828125 -9.46875 C 8.828125 -8.90625 8.664062 -8.367188 8.34375 -7.859375 C 8.03125 -7.359375 7.5625 -7.109375 6.9375 -7.109375 Z M 5.6875 -7.109375 "/></g></g></g><g fill="#ffffff" fill-opacity="1"><g transform="translate(54.418583, 25.671794)"><g><path d="M 5.6875 -7.109375 C 5.351562 -7.109375 5.113281 -6.976562 4.96875 -6.71875 C 4.820312 -6.457031 4.75 -6.148438 4.75 -5.796875 C 4.75 -5.429688 4.832031 -5.117188 5 -4.859375 C 5.164062 -4.609375 5.394531 -4.398438 5.6875 -4.234375 C 5.976562 -4.078125 6.300781 -3.96875 6.65625 -3.90625 C 7.019531 -3.84375 7.382812 -3.8125 7.75 -3.8125 C 8.332031 -3.8125 8.875 -3.875 9.375 -4 C 9.882812 -4.132812 10.328125 -4.296875 10.703125 -4.484375 L 10.703125 -15.125 C 10.703125 -15.382812 10.78125 -15.640625 10.9375 -15.890625 C 11.09375 -16.140625 11.289062 -16.347656 11.53125 -16.515625 C 11.769531 -16.679688 12.046875 -16.816406 12.359375 -16.921875 C 12.671875 -17.023438 12.972656 -17.078125 13.265625 -17.078125 C 13.734375 -17.078125 14.125 -16.953125 14.4375 -16.703125 C 14.757812 -16.453125 14.921875 -16.054688 14.921875 -15.515625 L 14.921875 -5.3125 C 14.921875 -4.414062 14.71875 -3.617188 14.3125 -2.921875 C 13.90625 -2.234375 13.363281 -1.648438 12.6875 -1.171875 C 12.019531 -0.703125 11.253906 -0.347656 10.390625 -0.109375 C 9.523438 0.117188 8.644531 0.234375 7.75 0.234375 C 6.71875 0.234375 5.773438 0.0859375 4.921875 -0.203125 C 4.066406 -0.492188 3.320312 -0.890625 2.6875 -1.390625 C 2.0625 -1.898438 1.570312 -2.488281 1.21875 -3.15625 C 0.875 -3.832031 0.703125 -4.550781 0.703125 -5.3125 C 0.703125 -5.96875 0.835938 -6.625 1.109375 -7.28125 C 1.378906 -7.945312 1.816406 -8.617188 2.421875 -9.296875 C 2.046875 -9.742188 1.722656 -10.234375 1.453125 -10.765625 C 1.179688 -11.304688 1.046875 -11.867188 1.046875 -12.453125 C 1.046875 -13.015625 1.132812 -13.5625 1.3125 -14.09375 C 1.488281 -14.625 1.753906 -15.085938 2.109375 -15.484375 C 2.472656 -15.890625 2.929688 -16.210938 3.484375 -16.453125 C 4.035156 -16.703125 4.671875 -16.828125 5.390625 -16.828125 L 7 -16.828125 C 7.539062 -16.828125 7.929688 -16.660156 8.171875 -16.328125 C 8.421875 -15.992188 8.546875 -15.601562 8.546875 -15.15625 C 8.546875 -14.59375 8.375 -14.054688 8.03125 -13.546875 C 7.6875 -13.046875 7.195312 -12.796875 6.5625 -12.796875 L 5.65625 -12.796875 C 5.457031 -12.796875 5.3125 -12.703125 5.21875 -12.515625 C 5.125 -12.335938 5.078125 -12.148438 5.078125 -11.953125 C 5.078125 -11.753906 5.125 -11.566406 5.21875 -11.390625 C 5.3125 -11.222656 5.457031 -11.140625 5.65625 -11.140625 L 7.265625 -11.140625 C 7.804688 -11.140625 8.203125 -10.972656 8.453125 -10.640625 C 8.703125 -10.304688 8.828125 -9.914062 8.828125 -9.46875 C 8.828125 -8.90625 8.664062 -8.367188 8.34375 -7.859375 C 8.03125 -7.359375 7.5625 -7.109375 6.9375 -7.109375 Z M 5.6875 -7.109375 "/></g></g></g><g fill="#ffffff" fill-opacity="1"><g transform="translate(70.341469, 25.671794)"><g><path d="M 14.953125 -1.71875 C 14.953125 -1.425781 14.875 -1.15625 14.71875 -0.90625 C 14.5625 -0.65625 14.363281 -0.445312 14.125 -0.28125 C 13.882812 -0.113281 13.613281 0.0078125 13.3125 0.09375 C 13.007812 0.1875 12.710938 0.234375 12.421875 0.234375 C 11.972656 0.234375 11.578125 0.113281 11.234375 -0.125 C 10.898438 -0.375 10.734375 -0.769531 10.734375 -1.3125 L 10.734375 -10.84375 C 10.734375 -11.25 10.65625 -11.59375 10.5 -11.875 C 10.34375 -12.15625 10.132812 -12.378906 9.875 -12.546875 C 9.625 -12.710938 9.328125 -12.832031 8.984375 -12.90625 C 8.648438 -12.988281 8.304688 -13.03125 7.953125 -13.03125 C 7.390625 -13.03125 6.835938 -12.96875 6.296875 -12.84375 C 5.753906 -12.71875 5.304688 -12.566406 4.953125 -12.390625 L 5.21875 -10.640625 L 5.21875 -1.71875 C 5.21875 -1.425781 5.140625 -1.15625 4.984375 -0.90625 C 4.828125 -0.65625 4.628906 -0.445312 4.390625 -0.28125 C 4.160156 -0.113281 3.890625 0.0078125 3.578125 0.09375 C 3.273438 0.1875 2.976562 0.234375 2.6875 0.234375 C 2.238281 0.234375 1.847656 0.113281 1.515625 -0.125 C 1.179688 -0.375 1.015625 -0.769531 1.015625 -1.3125 L 1.015625 -7.8125 C 1.015625 -8.351562 1.054688 -8.894531 1.140625 -9.4375 C 1.234375 -9.988281 1.367188 -10.503906 1.546875 -10.984375 C 1.328125 -11.398438 1.128906 -11.898438 0.953125 -12.484375 C 0.785156 -13.078125 0.660156 -13.742188 0.578125 -14.484375 C 1.742188 -15.171875 2.957031 -15.773438 4.21875 -16.296875 C 5.488281 -16.816406 6.765625 -17.078125 8.046875 -17.078125 C 8.859375 -17.078125 9.671875 -16.957031 10.484375 -16.71875 C 11.304688 -16.476562 12.046875 -16.117188 12.703125 -15.640625 C 13.367188 -15.160156 13.910156 -14.546875 14.328125 -13.796875 C 14.742188 -13.054688 14.953125 -12.171875 14.953125 -11.140625 Z M 14.953125 -1.71875 "/></g></g></g><g fill="#ffffff" fill-opacity="1"><g transform="translate(86.298016, 25.671794)"><g><path d="M 5.21875 -4.046875 L 5.453125 -4.046875 C 6.054688 -4.046875 6.523438 -3.804688 6.859375 -3.328125 C 7.203125 -2.859375 7.375 -2.34375 7.375 -1.78125 C 7.375 -1.3125 7.242188 -0.894531 6.984375 -0.53125 C 6.722656 -0.175781 6.300781 0 5.71875 0 L 4.875 0 C 3.46875 0 2.472656 -0.328125 1.890625 -0.984375 C 1.304688 -1.648438 1.015625 -2.601562 1.015625 -3.84375 L 1.015625 -15.125 C 1.015625 -15.414062 1.085938 -15.679688 1.234375 -15.921875 C 1.378906 -16.171875 1.570312 -16.378906 1.8125 -16.546875 C 2.0625 -16.710938 2.335938 -16.84375 2.640625 -16.9375 C 2.941406 -17.03125 3.25 -17.078125 3.5625 -17.078125 C 4.019531 -17.078125 4.410156 -16.953125 4.734375 -16.703125 C 5.054688 -16.453125 5.21875 -16.054688 5.21875 -15.515625 Z M 12.296875 -4.046875 L 12.53125 -4.046875 C 13.132812 -4.046875 13.601562 -3.804688 13.9375 -3.328125 C 14.269531 -2.859375 14.4375 -2.34375 14.4375 -1.78125 C 14.4375 -1.3125 14.304688 -0.894531 14.046875 -0.53125 C 13.796875 -0.175781 13.378906 0 12.796875 0 L 11.953125 0 C 10.535156 0 9.535156 -0.328125 8.953125 -0.984375 C 8.367188 -1.648438 8.078125 -2.601562 8.078125 -3.84375 L 8.078125 -15.125 C 8.078125 -15.414062 8.148438 -15.679688 8.296875 -15.921875 C 8.441406 -16.171875 8.640625 -16.378906 8.890625 -16.546875 C 9.140625 -16.710938 9.414062 -16.84375 9.71875 -16.9375 C 10.019531 -17.03125 10.328125 -17.078125 10.640625 -17.078125 C 11.085938 -17.078125 11.472656 -16.953125 11.796875 -16.703125 C 12.128906 -16.453125 12.296875 -16.054688 12.296875 -15.515625 Z M 12.296875 -4.046875 "/></g></g></g><g fill="#ffffff" fill-opacity="1"><g transform="translate(100.739705, 25.671794)"><g><path d="M 12.09375 -14.40625 L 14.4375 -6.03125 L 16.0625 -15.359375 C 16.101562 -15.628906 16.21875 -15.863281 16.40625 -16.0625 C 16.601562 -16.257812 16.835938 -16.4375 17.109375 -16.59375 C 17.378906 -16.75 17.671875 -16.867188 17.984375 -16.953125 C 18.296875 -17.035156 18.597656 -17.078125 18.890625 -17.078125 C 19.472656 -17.078125 19.910156 -16.914062 20.203125 -16.59375 C 20.492188 -16.28125 20.5625 -15.800781 20.40625 -15.15625 L 17.078125 -1.75 C 16.890625 -1.070312 16.515625 -0.570312 15.953125 -0.25 C 15.398438 0.0703125 14.796875 0.234375 14.140625 0.234375 C 13.691406 0.234375 13.269531 0.125 12.875 -0.09375 C 12.488281 -0.320312 12.226562 -0.695312 12.09375 -1.21875 L 10.4375 -7.609375 L 9.03125 -1.6875 C 8.894531 -1.101562 8.535156 -0.632812 7.953125 -0.28125 C 7.367188 0.0625 6.75 0.234375 6.09375 0.234375 C 5.53125 0.234375 5.054688 0.117188 4.671875 -0.109375 C 4.296875 -0.347656 4.050781 -0.71875 3.9375 -1.21875 L 0.609375 -14.71875 C 0.453125 -15.34375 0.554688 -15.890625 0.921875 -16.359375 C 1.296875 -16.835938 1.832031 -17.078125 2.53125 -17.078125 C 3.0625 -17.078125 3.539062 -16.96875 3.96875 -16.75 C 4.394531 -16.539062 4.65625 -16.210938 4.75 -15.765625 L 6.390625 -6.03125 L 7.953125 -15.328125 C 8.054688 -15.878906 8.382812 -16.304688 8.9375 -16.609375 C 9.488281 -16.921875 10.085938 -17.078125 10.734375 -17.078125 C 11.390625 -17.078125 11.859375 -16.914062 12.140625 -16.59375 C 12.421875 -16.28125 12.472656 -15.8125 12.296875 -15.1875 Z M 12.09375 -14.40625 "/></g></g></g><g fill="#ffffff" fill-opacity="1"><g transform="translate(121.779464, 25.671794)"><g><path d="M -5.390625 -18.625 C -5.953125 -18.625 -6.429688 -18.742188 -6.828125 -18.984375 C -7.234375 -19.234375 -7.5625 -19.550781 -7.8125 -19.9375 L -7.8125 -19.59375 C -7.8125 -19.238281 -7.925781 -18.96875 -8.15625 -18.78125 C -8.394531 -18.601562 -8.6875 -18.515625 -9.03125 -18.515625 C -9.675781 -18.515625 -10.25 -18.769531 -10.75 -19.28125 C -11.257812 -19.800781 -11.515625 -20.59375 -11.515625 -21.65625 C -11.515625 -22.101562 -11.453125 -22.5625 -11.328125 -23.03125 C -11.203125 -23.5 -11.015625 -23.925781 -10.765625 -24.3125 C -10.523438 -24.695312 -10.207031 -25.003906 -9.8125 -25.234375 C -9.414062 -25.472656 -8.953125 -25.59375 -8.421875 -25.59375 L -2.59375 -25.59375 C -2.144531 -25.59375 -1.789062 -25.382812 -1.53125 -24.96875 C -1.269531 -24.550781 -1.140625 -24.117188 -1.140625 -23.671875 C -1.140625 -23.359375 -1.21875 -23.078125 -1.375 -22.828125 C -1.53125 -22.578125 -1.789062 -22.453125 -2.15625 -22.453125 L -7.8125 -22.453125 C -7.269531 -21.984375 -6.617188 -21.75 -5.859375 -21.75 L -3.734375 -21.75 C -3.359375 -21.75 -3.082031 -21.617188 -2.90625 -21.359375 C -2.738281 -21.109375 -2.65625 -20.8125 -2.65625 -20.46875 C -2.65625 -20.019531 -2.785156 -19.597656 -3.046875 -19.203125 C -3.304688 -18.816406 -3.679688 -18.625 -4.171875 -18.625 Z M -5.390625 -18.625 "/></g></g></g><g fill="#ffffff" fill-opacity="1"><g transform="translate(121.779464, 25.671794)"><g><path d="M 10.84375 -10.8125 C 10.84375 -11.164062 10.75 -11.484375 10.5625 -11.765625 C 10.382812 -12.046875 10.144531 -12.273438 9.84375 -12.453125 C 9.539062 -12.640625 9.207031 -12.78125 8.84375 -12.875 C 8.488281 -12.976562 8.125 -13.03125 7.75 -13.03125 C 6.976562 -13.03125 6.296875 -12.820312 5.703125 -12.40625 C 5.109375 -11.988281 4.8125 -11.332031 4.8125 -10.4375 C 4.8125 -10.320312 4.816406 -10.179688 4.828125 -10.015625 C 4.835938 -9.847656 4.867188 -9.695312 4.921875 -9.5625 C 5.179688 -9.757812 5.441406 -9.894531 5.703125 -9.96875 C 5.960938 -10.050781 6.316406 -10.09375 6.765625 -10.09375 L 8.453125 -10.09375 C 8.941406 -10.09375 9.316406 -9.925781 9.578125 -9.59375 C 9.835938 -9.257812 9.96875 -8.832031 9.96875 -8.3125 C 9.96875 -7.664062 9.796875 -7.128906 9.453125 -6.703125 C 9.117188 -6.273438 8.5625 -6.0625 7.78125 -6.0625 L 7.234375 -6.0625 C 6.898438 -6.0625 6.660156 -5.992188 6.515625 -5.859375 C 6.367188 -5.722656 6.265625 -5.5 6.203125 -5.1875 L 5.390625 -1.28125 C 5.316406 -1.007812 5.191406 -0.773438 5.015625 -0.578125 C 4.835938 -0.390625 4.613281 -0.234375 4.34375 -0.109375 C 4.070312 0.00390625 3.78125 0.0859375 3.46875 0.140625 C 3.15625 0.203125 2.84375 0.234375 2.53125 0.234375 C 1.894531 0.234375 1.429688 0.117188 1.140625 -0.109375 C 0.847656 -0.347656 0.78125 -0.769531 0.9375 -1.375 L 2.1875 -6.5625 C 1.695312 -7.238281 1.3125 -7.945312 1.03125 -8.6875 C 0.75 -9.425781 0.609375 -10.15625 0.609375 -10.875 C 0.609375 -11.90625 0.804688 -12.804688 1.203125 -13.578125 C 1.609375 -14.359375 2.148438 -15.003906 2.828125 -15.515625 C 3.503906 -16.035156 4.265625 -16.425781 5.109375 -16.6875 C 5.960938 -16.945312 6.84375 -17.078125 7.75 -17.078125 C 8.644531 -17.078125 9.53125 -16.945312 10.40625 -16.6875 C 11.28125 -16.425781 12.054688 -16.039062 12.734375 -15.53125 C 13.421875 -15.03125 13.976562 -14.398438 14.40625 -13.640625 C 14.832031 -12.878906 15.046875 -11.992188 15.046875 -10.984375 L 15.046875 -1.71875 C 15.046875 -1.425781 14.96875 -1.15625 14.8125 -0.90625 C 14.65625 -0.65625 14.457031 -0.445312 14.21875 -0.28125 C 13.988281 -0.113281 13.722656 0.0078125 13.421875 0.09375 C 13.117188 0.1875 12.820312 0.234375 12.53125 0.234375 C 12.082031 0.234375 11.6875 0.113281 11.34375 -0.125 C 11.007812 -0.375 10.84375 -0.769531 10.84375 -1.3125 Z M 10.84375 -10.8125 "/></g></g></g></svg>
					<svg height="20" viewBox="0 0 20 20" width="20" class="shopee-svg-icon _8tjJ2v">
						<g fill="none" fill-rule="evenodd" stroke="#fff" stroke-width="1.8" transform="translate(1 1)">
							<circle cx="9" cy="9" r="9"></circle>
							<path d="m11.5639648 5.05283203v4.71571528l-2.72832027 1.57129639" stroke-linecap="round" stroke-linejoin="round" transform="matrix(-1 0 0 1 20.39961 0)"></path>
						</g>
					</svg>
					<div class="FteIo2" style="font-weight: 500;" >จบใน</div>
					<count-down
									class="count-down"
									v-on:start_callback="countDownS_cb()"
									v-on:end_callback="countDownE_cb()"
									:currentTime="groupbuyTimeMachine.currentTime"
									:startTime="groupbuyTimeMachine.startTime"
									:endTime="groupbuyTimeMachine.endTime"
									:dayTxt="'วัน'"
									:hourTxt="'：'"
									:minutesTxt="'：'"
									:secondsTxt="''"
								></count-down>
				
					
					
					
					
					
					
					
					
					
						</div>
				<div class="flex flex-column">
					<div class="flex flex-column LR5fT5">
						<div class="flex items-center">
							<div class="flex items-center _9GxTz3">
								<div class="Kg2R-S" style="font-weight: 900; font-family: 'sukhumvittadmai2'; " >฿{{ goodsSkuDetail.price }}</div>
								<div class="flex items-center">
									<div class="X0xUb5" style="font-weight: 900; font-family: 'sukhumvittadmai2'; ">฿{{ goodsSkuDetail.groupbuy_price }}</div>
									<div class="+1IO+x" stle="    font-family: 'sukhumvittadmai2';">{{((1-(goodsSkuDetail.groupbuy_price/goodsSkuDetail.price))*100).toFixed(2) }}% ส่วนลด</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			

			<div class="item-block" style="    margin-top: -0px;" >
				<div class="promotion-price">
					

					<div class="statistical" style="    margin-top: -90px;">
						<ul>
							<li>
								<p style="    font-family: sukhumvittadmai2; margin: 0.2rem 0;">รีวิวสินค้า</p>
								<span>{{ goodsSkuDetail.evaluate }}</span>
							</li>
							<li>
								<p style="    font-family: sukhumvittadmai2; margin: 0.2rem 0;" >ยอดขาย</p>
								<span>{{ goodsSkuDetail.sale_num }}{{ goodsSkuDetail.unit }}</span>
							</li>
						</ul>
					</div>

					<dl class="item-line" v-if="goodsSkuDetail.is_virtual == 0">
						<dt>จัดส่ง</dt>
						<dd>
							<i class="i-activity-flag ns-text-color ns-border-color" v-if="goodsSkuDetail.is_free_shipping">จัดส่งฟรี</i>
							<i class="i-activity-flag ns-text-color ns-border-color" v-else>การจัดส่งแบบปกติ</i>
						</dd>
					</dl>
				</div>
			</div>
			<dl class="item-line delivery" v-if="goodsSkuDetail.is_virtual == 0">
				<dt>สถานที่</dt>
				<dd>
					<div class="region-selected ns-border-color-gray">
						<span>
							<template v-if="selectedAddress['level_1']">
								<template v-for="item in selectedAddress">
									{{ item.name }}
								</template>
							</template>
							<template v-else>
								โปรดเลือกที่อยู่จัดส่ง
							</template>
						</span>
						<i class="el-icon-arrow-down"></i>
					</div>

					<div class="region-list ns-border-color-gray" :class="{ hide: hideRegion }">
						<ul class="nav-tabs">
							<li :class="{ active: currTabAddres == 'province' }" @click="currTabAddres = 'province'">
								<div>
									<span>{{ selectedAddress['level_1'] ? selectedAddress['level_1'].name : 'โปรดเลือกจังหวัด' }}</span>
									<i class="el-icon-arrow-down"></i>
								</div>
							</li>
							<li :class="{ active: currTabAddres == 'city' }" @click="currTabAddres = 'city'">
								<div>
									<span>{{ selectedAddress['level_2'] ? selectedAddress['level_2'].name : 'โปรดเลือกเมือง' }}</span>
									<i class="el-icon-arrow-down"></i>
								</div>
							</li>
							<li :class="{ active: currTabAddres == 'district' }" @click="currTabAddres = 'district'">
								<div>
									<span>{{ selectedAddress['level_3'] ? selectedAddress['level_3'].name : 'โปรดเลือกโซน/เขต' }}</span>
									<i class="el-icon-arrow-down"></i>
								</div>
							</li>
						</ul>
						<div class="tab-content">
							<div class="tab-pane" :class="{ active: currTabAddres == 'province' }">
								<ul class="province">
									<li v-for="(item, index) in provinceArr" :key="index" :class="{ selected: selectedAddress['level_' + item.level] && selectedAddress['level_' + item.level].id == item.id }">
										<span @click="getAddress('city', item)">{{ item.name }}</span>
									</li>
								</ul>
							</div>
							<div class="tab-pane" :class="{ active: currTabAddres == 'city' }">
								<ul class="city">
									<li v-for="(item, index) in cityArr" :key="index" :class="{ selected: selectedAddress['level_' + item.level] && selectedAddress['level_' + item.level].id == item.id }">
										<span @click="getAddress('district', item)">{{ item.name }}</span>
									</li>
								</ul>
							</div>
							<div class="tab-pane" :class="{ active: currTabAddres == 'district' }">
								<ul class="district">
									<li v-for="(item, index) in districtArr" :key="index" :class="{ selected: selectedAddress['level_' + item.level] && selectedAddress['level_' + item.level].id == item.id }">
										<span @click="getAddress('community', item)">{{ item.name }}</span>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</dd>
			</dl>
			<dl class="item-line service">
				<dt>บริการเสริม</dt>
				<dd>
					<span>
						เรา
						<span class="ns-text-color">{{siteInfo.site_name}}</span>
						บริการจัดส่งและบริการหลังการขาย
					</span>
				</dd>
			</dl>
			<hr class="divider" />
			<div class="sku-list" v-if="goodsSkuDetail.goods_spec_format">
				<dl class="item-line" v-for="(item, index) in goodsSkuDetail.goods_spec_format" :key="index">
					<dt>{{ item.spec_name }}</dt>
					<dd>
						<ul>
							<li v-for="(item_value, index_value) in item.value" :key="index_value">
								<div :class="{
										'selected ns-border-color': item_value['selected'] || skuId == item_value.sku_id,
										disabled: item_value['disabled'] || (!item_value['selected'] && specDisabled)
									}"
								 @click="changeSpec(item_value.sku_id, item_value.spec_id)">
									<img v-if="item_value.image" :src="$img(item_value.image, { size: 'small' })" />
									<span>{{ item_value.spec_value_name }}</span>
									<i class="iconfont iconduigou1 ns-text-color"></i>
								</div>
							</li>
						</ul>
					</dd>
				</dl>
			</div>

			<div class="buy-number">
				<dl class="item-line">
					<dt>ปริมาณ</dt>
					<dd>
						<div class="num-wrap">
							<el-input v-model="number" placeholder="0" @input="keyInput(false)" @blur="blur"></el-input>
							<div class="operation">
								<span class="increase el-icon-caret-top" @click="changeNum('+')"></span>
								<span class="decrease el-icon-caret-bottom" @click="changeNum('-')"></span>
							</div>
						</div>
						<span class="unit">{{ goodsSkuDetail.unit }}</span>
						<span class="inventory">เหลือสินค้า {{ goodsSkuDetail.stock }} {{ goodsSkuDetail.unit }}</span>
						<!-- การซื้อแบบจํากัด -->
						<em v-if="limitNumber > 0" style="    font-weight: 500;">(ขั้นต่ำที่ต้องซื้อ {{ limitNumber }} {{ goodsSkuDetail.unit }})</em>
					</dd>
				</dl>
			</div>

			<dl class="item-line buy-btn">
				<dt></dt>
				<dd v-if="goodsSkuDetail.goods_state == 1">
					<template v-if="goodsSkuDetail.goods_stock < goodsSkuDetail.buy_num && !goodsSkuDetail.sku_spec_format">
						<el-button type="info" plain disabled>สินค้าคงคลังไม่เพียงพอ</el-button>
					</template>
					<template v-else>
						<el-button type="primary" plain @click="buyNow"  style="    font-weight: 700; font-family: 'sukhumvittadmai2'; " >ซื้อเลย</el-button>
					</template>
					<div href="javascript:;" class="go-phone">
						<img src="@/assets/images/goods/qrcode.png" />
						<div class="qrcode-wrap"><img :src="qrcode" alt="รูปภาพรหัส QR" /></div>
					</div>
				</dd>

				<dd v-else>
					<template>
						<el-button type="info"  style="    font-weight: 700; font-family: 'sukhumvittadmai2'; " plain disabled >สินค้าไม่มีแล้ว</el-button>
					</template>
					<div href="javascript:;" class="go-phone">
						<img src="@/assets/images/goods/qrcode.png" />
						<div class="qrcode-wrap"><img :src="qrcode" alt="รูปภาพรหัส QR" /></div>
					</div>
				</dd>

			</dl>
			<!-- 	shopInfo.shop_baozh == 1 ||
			shopInfo.shop_qtian == 1 ||
			shopInfo.shop_zhping == 1 ||
			shopInfo.shop_erxiaoshi == 1 ||
			shopInfo.shop_tuihuo == 1 ||
			shopInfo.shop_shiyong == 1 ||
			shopInfo.shop_shiti == 1 ||
			shopInfo.shop_xiaoxie == 1 -->
			<dl class="item-line merchant-service" v-show="service_list.length">
				<dt>สินค้าและบริการ</dt>
				<div>
					<dd class="service-li" v-for="item in service_list">
						<i class="el-icon-success"></i>
						<span class="ns-text-color-gray" :title="item.service_name">{{item.service_name}}</span>
					</dd>
				</div>
			</dl>
		</div>

		<!-- ข้อมูลร้าน -->
		<!-- <div class="shop-wrap">
			<div class="head-wrap">
				<div class="img-wrap">
					<img class="img-responsive center-block" :src="shopInfo.avatar ? $img(shopInfo.avatar) : $img(defaultShopImage)"
					 @error="shopInfo.avatar = defaultShopImage" :alt="shopInfo.site_name" />
				</div>
				<h5>
					<span class="site-name">{{ shopInfo.site_name }}</span>
					<el-tag class="tag" size="small" v-if="shopInfo.is_own == 1">ดําเนินการด้วยตนเอง</el-tag>
				</h5>
			</div>
			<div class="info-wrap">
				<dl>
					<dt class="site-score">การให้คะแนนร้านค้า</dt>
					<dd>
						<el-rate v-model="score" disabled></el-rate>
					</dd>
					<dt>รายละเอียดสินค้า：</dt>
					<dd>
						<span>{{ shopInfo.shop_desccredit }}</span>
						แบ่ง
					</dd>
					<dt>บริการสําหรับผู้ขาย：</dt>
					<dd>
						<span>{{ shopInfo.shop_servicecredit }}</span>
						แบ่ง
					</dd>
					<dt>ความเร็วในการจัดส่ง：</dt>
					<dd>
						<span>{{ shopInfo.shop_deliverycredit }}</span>
						แบ่ง
					</dd>
				</dl>
			</div>
			<div class="info-wrap" v-if="shopInfo.telephone">
				<dl>
					<dt>เบอร์ติดต่อ：</dt>
					<dd>{{ shopInfo.telephone }}</dd>
				</dl>
			</div>
			<div class="operation">
				<el-button class="btn btn-default" size="medium" @click="$router.pushToTab('/shop-' + shopInfo.site_id)">เข้ามาและเดินไปรอบ ๆ</el-button>
				<el-button size="medium" @click="follow" v-if="hasFollow">เลิกติดตาม</el-button>
				<el-button size="medium" @click="follow" v-else>ติดตามร้านค้าของคุณ</el-button>
			</div>
		</div> -->

		<div class="detail-wrap">
			

			<el-tabs class="goods-tab" v-model="tabName"  @tab-click="tabChange">
				<el-tab-pane label="รายละเอียดสินค้า" name="detail">
					<div v-html="goodsSkuDetail.goods_content"></div>
					
					
					<div class="empty animate__animated animate__fadeIn" v-if="goodsSkuDetail.goods_content==''" style="color: #898989;
					    text-align: center;
					    font-size: 14px;"><div class="el-empty" data-v-1ab1ffd8="">
					   <div class="el-empty__image" style="width: 200px;">
					     <img src="https://i.imgur.com/VrthEHO.png">
					   </div>
					   <div class="el-empty__description">
					      <p style="font-family: 'sukhumvittadmai';">ไม่มีรายละเอียดสินค้า</p>
					   </div>
					   <!--v-if-->
					</div></div>
					
					
				</el-tab-pane>
				<el-tab-pane label="แอตทริบิวต์ผลิตภัณฑ์" name="attr">
					<ul class="attr-list">
						<template v-if="goodsSkuDetail.goods_attr_format && goodsSkuDetail.goods_attr_format.length > 0">
							<li v-for="(item, index) in goodsSkuDetail.goods_attr_format" :key="index">{{ item.attr_name }}：{{ item.attr_value_name }}</li>
						</template>
						
					</ul>
					
					<div class="empty  animate__animated animate__fadeIn" v-if="goodsSkuDetail.goods_attr_format.length == 0" style="color: #898989;
					    text-align: center;
					    font-size: 14px;"><div class="el-empty" data-v-1ab1ffd8="">
					   <div class="el-empty__image" style="width: 200px;">
					    <img src="https://i.imgur.com/VrthEHO.png">
					   </div>
					   <div class="el-empty__description">
					      <p style="font-family: 'sukhumvittadmai';">ไม่มี แอตทริบิวต์ผลิตภัณฑ์ นี้</p>
					   </div>
					   <!--v-if-->
					</div></div>
					
					
					
					
					
				</el-tab-pane>
				<el-tab-pane v-if="evaluate_show" :label="evaluteCount.total ? 'รีวิวสินค้า(' + evaluteCount.total + ')' : 'รีวิวสินค้า'"
								 name="evaluate" class="evaluate">
									<template v-if="evaluteCount.total">
										<nav>
											<li :class="evaluaType == 0 ? 'selected' : ''" @click="evaluationType(0)">รีวิวทั้งหมด({{evaluteCount.total}})</li>
											<li :class="evaluaType == 1 ? 'selected' : ''" @click="evaluationType(1)">ยอดเยี่ยม({{evaluteCount.haoping}})</li>
											<li :class="evaluaType == 2 ? 'selected' : ''" @click="evaluationType(2)">ปลานกลาง({{evaluteCount.zhongping}})</li>
											<li :class="evaluaType == 3 ? 'selected' : ''" @click="evaluationType(3)">ไม่ค่อยดี({{evaluteCount.chaping}})</li>
										</nav>
										<ul class="list">
											<li v-for="(item, index) in goodsEvaluateList" :key="index">
												<div class="member-info">
													<img v-if="item.member_headimg==''" :src="'https://www.pngarts.com/files/11/Avatar-PNG-Download-Image.png'" @error="imageErrorEvaluate(index)" class="avatar" />
													<img v-else :src="$img(item.member_headimg)" @error="imageErrorEvaluate(index)" class="avatar" />
													<span>{{ item.member_name }}</span>
												</div>
												<div class="info-wrap">
													<el-rate v-model="item.star" disabled></el-rate>
													<p class="content">{{ item.content }}</p>
													<div class="img-list" v-if="item.images">
														<el-image v-for="(img, img_index) in item.images" :key="img_index" :src="$img(img)" :preview-src-list="item.imagesFormat"></el-image>
													</div>
													<div class="sku-info">
														<span>{{ item.sku_name }}</span>
														<span class="create-time">เวลาที่รีวิว :{{ $util.timeStampTurnTime(item.create_time) }}</span>
													</div>
													<div class="evaluation-reply" v-if="item.explain_first != ''">ร้านค้าตอบ：{{ item.explain_first }}</div>
													<template v-if="item.again_is_audit == 1 ">
														<div class="review-evaluation">
															<span>การประเมินเพิ่มเติม</span>
															<span class="review-time">{{ $util.timeStampTurnTime(item.again_time) }}</span>
														</div>
														<p class="content">{{ item.again_content }}</p>
														<div class="img-list">
															<el-image v-for="(again_img, again_index) in item.again_images" :key="again_index" :src="$img(again_img)"
															 :preview-src-list="item.againImagesFormat"></el-image>
														</div>
														<div class="evaluation-reply" v-if="item.again_explain != ''">ร้านค้าตอบ：{{ item.again_explain }}</div>
													</template>
												</div>
											</li>
										</ul>
										<div class="pager">
											<el-pagination background :pager-count="5" :total="total" prev-text="ก่อน" next-text="ต่อไป" :current-page.sync="currentPage"
											 :page-size.sync="pageSize" @size-change="handlePageSizeChange" @current-change="handleCurrentPageChange"
											 hide-on-single-page></el-pagination>
										</div>
									</template>
									<div class="empty animate__animated animate__fadeIn" v-else>  <div class="el-empty" data-v-1ab1ffd8="">
				   <div class="el-empty__image" style="width: 200px;">
				      <img src="https://i.imgur.com/VrthEHO.png">
				   </div>
				   <div class="el-empty__description">
				      <p style="font-family: 'sukhumvittadmai';">ยังไม่มีรีวิวสินค้านี้</p>
				   </div>
				   <!--v-if-->
				</div>
				</div>
								</el-tab-pane>
				<template v-if="service">
					<el-tab-pane v-if="service.is_display == 1" label="การป้องกันหลังการขาย" name="after_sale" class="after-sale"><div v-html="service.content"></div></el-tab-pane>
				</template>
			</el-tabs>
		</div>
		<div class="goods-recommended">
						<goods-recommend />
					</div>
		<!--ติดต่อหน้าต่างป็อปอัพบริการลูกค้า-->
		<servicerMessage ref="servicerMessage" class="kefu" :shop="{shop_id:shopInfo.site_id,logo:shopInfo.logo,shop_name:shopInfo.site_name}"></servicerMessage>
	</div>
</template>

<script>
	import PicZoom from 'vue-piczoom';
	import detail from './detail_groupbuy.js';
	import GoodsRecommend from '@/components/GoodsRecommend';
	import servicerMessage from "@/components/message/servicerMessage";
	export default {
		name: 'groupbuy_detail',
		components: {
			PicZoom,
			GoodsRecommend,
			servicerMessage
		},
		mixins: [detail]
	};
</script>
<style lang="scss">
	@import './detail_groupbuy.scss';
	
	
		.stardust-icon {
			stroke: currentColor;
			fill: currentColor;
			width: 1em;
			height: 1em;
		}
		
		svg:not(:root) {
			overflow: hidden;
		}
		
		.flex {
			display: flex;
		}
		
		.flex-column {
			flex-direction: column;
		}
		
		.items-center {
			align-items: center;
		}
		
		.shopee-svg-icon {
			display: inline-block;
			width: 1em;
			height: 1em;
			fill: currentColor;
			position: relative;
		}
		
		
		/*! CSS Used from: https://deo.shopeemobile.com/shopee/shopee-pcmall-live-sg/homepage/pcmall-homepage.a1e800ee1e859a5df100.css */
		
		.stardust-icon {
			stroke: currentColor;
			fill: currentColor;
			width: 1em;
			height: 1em;
		}
		
		
		/*! CSS Used from: https://deo.shopeemobile.com/shopee/shopee-pcmall-live-sg/homepage/HomeOfficialShopSection.ec62e6cc621fd63669d7.css */
		
		.flex {
			display: flex;
		}
		
		.flex-column {
			flex-direction: column;
		}
		
		.items-center {
			align-items: center;
		}
		
		
		/*! CSS Used from: https://deo.shopeemobile.com/shopee/shopee-pcmall-live-sg/flashsale/426.a1cfaea72a580ba6d387.legacy.css */
		
		.stardust-icon {
			stroke: currentColor;
			fill: currentColor;
			width: 1em;
			height: 1em;
		}
		
		.shopee-countdown-timer {
			-webkit-backface-visibility: hidden;
			backface-visibility: hidden;
			cursor: default;
			display: flex;
			color: #000;
			align-items: center;
		}
		
		.shopee-countdown-timer__colon {
			display: flex;
			flex-direction: column;
			background-position-y: 3px;
			text-align: center;
			width: 3px;
			height: 17px;
			font-weight: 400;
			font-size: 20px;
			margin: 0 2px;
		}
		
		.shopee-countdown-timer__colon--flashing-off {
			opacity: 0;
		}
		
		.shopee-countdown-timer__number {
			background: currentColor;
			border-radius: 2px;
			height: 17px;
			margin-bottom: 4px;
			padding: 1px 3px;
			line-height: 20px;
			font-size: 19px;
			overflow: hidden;
			display: flex;
			justify-content: space-around;
			-moz-box-sizing: content-box;
			box-sizing: content-box;
			min-width: 20px;
			text-align: center;
		}
		
		.shopee-countdown-timer__number__deca,
		.shopee-countdown-timer__number__hexa {
			display: inline-block;
			width: 9px;
			height: 187px;
			overflow: hidden;
		}
		
		.shopee-countdown-timer__number__deca--second {
			-webkit-animation-name: second-digit;
			animation-name: second-digit;
			-webkit-animation-duration: 10s;
			animation-duration: 10s;
			-webkit-animation-iteration-count: infinite;
			animation-iteration-count: infinite;
		}
		
		.shopee-countdown-timer__number__hexa--second {
			-webkit-animation-name: second-ten;
			animation-name: second-ten;
			-webkit-animation-duration: 60s;
			animation-duration: 60s;
			-webkit-animation-iteration-count: infinite;
			animation-iteration-count: infinite;
		}
		
		.shopee-countdown-timer__number__deca--minute {
			-webkit-animation-name: minute-digit;
			animation-name: minute-digit;
			-webkit-animation-duration: 600s;
			animation-duration: 600s;
			-webkit-animation-iteration-count: infinite;
			animation-iteration-count: infinite;
		}
		
		.shopee-countdown-timer__number__hexa--minute {
			-webkit-animation-name: minute-ten;
			animation-name: minute-ten;
			-webkit-animation-duration: 3600s;
			animation-duration: 3600s;
			-webkit-animation-iteration-count: infinite;
			animation-iteration-count: infinite;
		}
		
		.shopee-countdown-timer__number__deca--hour {
			-webkit-animation-name: hour-digit;
			animation-name: hour-digit;
			-webkit-animation-duration: 36000s;
			animation-duration: 36000s;
			-webkit-animation-iteration-count: infinite;
			animation-iteration-count: infinite;
		}
		
		.shopee-countdown-timer__number__hexa--hour {
			-webkit-animation-name: hour-ten;
			animation-name: hour-ten;
			-webkit-animation-duration: 360000s;
			animation-duration: 360000s;
			-webkit-animation-iteration-count: infinite;
			animation-iteration-count: infinite;
		}
		
		.shopee-countdown-timer__number__item {
			position: relative;
			width: 9px;
			height: 17px;
		}
		
		.shopee-countdown-timer__number__item svg {
			position: absolute;
			top: 50%;
			left: 50%;
			-webkit-transform: translate(-50%, -50%);
			transform: translate(-50%, -50%);
			width: 17px;
			height: 13px;
			fill: #fff;
			stroke: #fff;
			overflow: visible;
		}
		
		.colon-dot {
			position: absolute;
			border-radius: 100%;
			width: 3px;
			height: 3px;
			top: 10%;
			left: 0;
			background: currentColor;
		}
		
		.colon-dot__wrapper {
			width: 100%;
			height: 50%;
			position: relative;
		}
		
		
		/*! CSS Used from: https://deo.shopeemobile.com/shopee/shopee-pcmall-live-sg/flashsale/426.a1cfaea72a580ba6d387.legacy.css */
		
		.stardust-icon {
			stroke: currentColor;
			fill: currentColor;
			width: 1em;
			height: 1em;
		}
		
		.shopee-countdown-timer {
			-webkit-backface-visibility: hidden;
			backface-visibility: hidden;
			cursor: default;
			display: flex;
			color: #000;
			align-items: center;
		}
		
		.shopee-countdown-timer__colon {
			display: flex;
			flex-direction: column;
			background-position-y: 3px;
			text-align: center;
			width: 3px;
			height: 17px;
			font-weight: 400;
			font-size: 20px;
			margin: 0 2px;
		}
		
		.shopee-countdown-timer__colon--flashing-off {
			opacity: 0;
		}
		
		.shopee-countdown-timer__number {
			background: currentColor;
			border-radius: 2px;
			height: 17px;
			margin-bottom: 4px;
			padding: 1px 3px;
			line-height: 20px;
			font-size: 19px;
			overflow: hidden;
			display: flex;
			justify-content: space-around;
			-moz-box-sizing: content-box;
			box-sizing: content-box;
			min-width: 20px;
			text-align: center;
		}
		
		.shopee-countdown-timer__number__deca,
		.shopee-countdown-timer__number__hexa {
			display: inline-block;
			width: 9px;
			height: 187px;
			overflow: hidden;
		}
		
		.shopee-countdown-timer__number__deca--second {
			-webkit-animation-name: second-digit;
			animation-name: second-digit;
			-webkit-animation-duration: 10s;
			animation-duration: 10s;
			-webkit-animation-iteration-count: infinite;
			animation-iteration-count: infinite;
		}
		
		.shopee-countdown-timer__number__hexa--second {
			-webkit-animation-name: second-ten;
			animation-name: second-ten;
			-webkit-animation-duration: 60s;
			animation-duration: 60s;
			-webkit-animation-iteration-count: infinite;
			animation-iteration-count: infinite;
		}
		
		.shopee-countdown-timer__number__deca--minute {
			-webkit-animation-name: minute-digit;
			animation-name: minute-digit;
			-webkit-animation-duration: 600s;
			animation-duration: 600s;
			-webkit-animation-iteration-count: infinite;
			animation-iteration-count: infinite;
		}
		
		.shopee-countdown-timer__number__hexa--minute {
			-webkit-animation-name: minute-ten;
			animation-name: minute-ten;
			-webkit-animation-duration: 3600s;
			animation-duration: 3600s;
			-webkit-animation-iteration-count: infinite;
			animation-iteration-count: infinite;
		}
		
		.shopee-countdown-timer__number__deca--hour {
			-webkit-animation-name: hour-digit;
			animation-name: hour-digit;
			-webkit-animation-duration: 36000s;
			animation-duration: 36000s;
			-webkit-animation-iteration-count: infinite;
			animation-iteration-count: infinite;
		}
		
		.shopee-countdown-timer__number__hexa--hour {
			-webkit-animation-name: hour-ten;
			animation-name: hour-ten;
			-webkit-animation-duration: 360000s;
			animation-duration: 360000s;
			-webkit-animation-iteration-count: infinite;
			animation-iteration-count: infinite;
		}
		
		.shopee-countdown-timer__number__item {
			position: relative;
			width: 9px;
			height: 17px;
		}
		
		.shopee-countdown-timer__number__item svg {
			position: absolute;
			top: 50%;
			left: 50%;
			-webkit-transform: translate(-50%, -50%);
			transform: translate(-50%, -50%);
			width: 17px;
			height: 13px;
			fill: #fff;
			stroke: #fff;
			overflow: visible;
		}
		
		.colon-dot {
			position: absolute;
			border-radius: 100%;
			width: 3px;
			height: 3px;
			top: 10%;
			left: 0;
			background: currentColor;
		}
		
		.colon-dot__wrapper {
			width: 100%;
			height: 50%;
			position: relative;
		}
		
		
		/*! CSS Used from: https://deo.shopeemobile.com/shopee/shopee-pcmall-live-sg/productdetailspage/pcmall-productdetailspage.ff0b3ccfbbc39630bc05.legacy.css */
		
		.stardust-icon {
			stroke: currentColor;
			fill: currentColor;
			width: 1em;
			height: 1em;
		}
		
		.shopee-countdown-timer {
			-webkit-backface-visibility: hidden;
			backface-visibility: hidden;
			cursor: default;
			display: flex;
			color: #000;
			align-items: center;
		}
		
		.shopee-countdown-timer__colon {
			display: flex;
			flex-direction: column;
			background-position-y: 3px;
			text-align: center;
			width: 3px;
			height: 17px;
			font-weight: 400;
			font-size: 20px;
			margin: 0 2px;
		}
		
		.shopee-countdown-timer__colon--flashing-off {
			opacity: 0;
		}
		
		.shopee-countdown-timer__number {
			background: currentColor;
			border-radius: 2px;
			height: 17px;
			margin-bottom: 4px;
			padding: 1px 3px;
			line-height: 20px;
			font-size: 19px;
			overflow: hidden;
			display: flex;
			justify-content: space-around;
			-moz-box-sizing: content-box;
			box-sizing: content-box;
			min-width: 20px;
			text-align: center;
		}
		
		.shopee-countdown-timer__number__deca,
		.shopee-countdown-timer__number__hexa {
			display: inline-block;
			width: 9px;
			height: 187px;
			overflow: hidden;
		}
		
		.shopee-countdown-timer__number__deca--second {
			-webkit-animation-name: second-digit;
			animation-name: second-digit;
			-webkit-animation-duration: 10s;
			animation-duration: 10s;
			-webkit-animation-iteration-count: infinite;
			animation-iteration-count: infinite;
		}
		
		.shopee-countdown-timer__number__hexa--second {
			-webkit-animation-name: second-ten;
			animation-name: second-ten;
			-webkit-animation-duration: 60s;
			animation-duration: 60s;
			-webkit-animation-iteration-count: infinite;
			animation-iteration-count: infinite;
		}
		
		.shopee-countdown-timer__number__deca--minute {
			-webkit-animation-name: minute-digit;
			animation-name: minute-digit;
			-webkit-animation-duration: 600s;
			animation-duration: 600s;
			-webkit-animation-iteration-count: infinite;
			animation-iteration-count: infinite;
		}
		
		.shopee-countdown-timer__number__hexa--minute {
			-webkit-animation-name: minute-ten;
			animation-name: minute-ten;
			-webkit-animation-duration: 3600s;
			animation-duration: 3600s;
			-webkit-animation-iteration-count: infinite;
			animation-iteration-count: infinite;
		}
		
		.shopee-countdown-timer__number__deca--hour {
			-webkit-animation-name: hour-digit;
			animation-name: hour-digit;
			-webkit-animation-duration: 36000s;
			animation-duration: 36000s;
			-webkit-animation-iteration-count: infinite;
			animation-iteration-count: infinite;
		}
		
		.shopee-countdown-timer__number__hexa--hour {
			-webkit-animation-name: hour-ten;
			animation-name: hour-ten;
			-webkit-animation-duration: 360000s;
			animation-duration: 360000s;
			-webkit-animation-iteration-count: infinite;
			animation-iteration-count: infinite;
		}
		
		.shopee-countdown-timer__number__item {
			position: relative;
			width: 9px;
			height: 17px;
		}
		
		.shopee-countdown-timer__number__item svg {
			position: absolute;
			top: 50%;
			left: 50%;
			-webkit-transform: translate(-50%, -50%);
			transform: translate(-50%, -50%);
			width: 17px;
			height: 13px;
			fill: #fff;
			stroke: #fff;
			overflow: visible;
		}
		
		.colon-dot {
			position: absolute;
			border-radius: 100%;
			width: 3px;
			height: 3px;
			top: 10%;
			left: 0;
			background: currentColor;
		}
		
		.colon-dot__wrapper {
			width: 100%;
			height: 50%;
			position: relative;
		}
		
		.flash-sale-logo {
			display: inline-block;
		}
		
		.flash-sale-logo--white,
		.hO9GFq {
			color: #fff;
		}
		
		.hO9GFq {
			display: flex;
			align-items: center;
			margin-top: .625rem;
			height: 36px;
			padding: 0 20px;
			background-image: url(https://i.imgur.com/WDQIGC3.png), linear-gradient(-90deg, #f0451e 9%, #f32424 96%);
		}
		
		.FteIo2 {
			text-transform: uppercase;
			margin-right: .625rem;
			font-weight: lighter;
		}
		
		._8tjJ2v {
			width: 17px;
			height: 17px;
			margin-left: auto;
			margin-right: 6px;
		}
		
		.Kg2R-S {
			font-size: 1rem;
			text-decoration: line-through;
			color: #929292;
			margin-right: 10px;
		}
		
		.X0xUb5 {
			font-size: 1.875rem;
			font-weight: 500;
			color: #ee4d2d;
		}
		
		.theme--ofs .X0xUb5 {
			color: #d0011b;
		}
		
		.\+1IO\+x {
			margin-left: 15px;
			font-size: .75rem;
			color: #fff;
			text-transform: uppercase;
			background: #ee4d2d;
			border-radius: 2px;
			padding: 2px 4px;
			font-weight: 600;
			line-height: 1;
			white-space: nowrap;
		}
		
		.theme--ofs .\+1IO\+x {
			background-color: #d0011b;
		}
		
		._9GxTz3 {
			flex-wrap: wrap;
			width: 625px;
			flex-basis: 625px;
			min-height: 1.875rem;
		}
		
		.LR5fT5 {
			padding: 15px 20px;
			background: #fafafa;
		}
		
		
		/*! CSS Used from: https://deo.shopeemobile.com/shopee/shopee-pcmall-live-sg/voucher/573.6f2c85ba2352c7f1c9c0.legacy.css */
		
		.stardust-icon {
			stroke: currentColor;
			fill: currentColor;
			width: 1em;
			height: 1em;
		}
		
		
		/*! CSS Used from: https://deo.shopeemobile.com/shopee/shopee-pcmall-live-sg/productdetailspage/1545.de836f8ab95af45532cc.legacy.css */
		
		.flex {
			display: flex;
		}
		
		
		/*! CSS Used keyframes */
		
		@-webkit-keyframes second-digit {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@keyframes second-digit {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@-webkit-keyframes second-digit {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@keyframes second-digit {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@-webkit-keyframes second-digit {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@keyframes second-digit {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@-webkit-keyframes second-ten {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			15% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			16.66% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			31.66% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			33.33% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			48.33% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			50% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			65% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			66.66% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			81.66% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			83.33% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			98.33% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			to {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
		}
		
		@keyframes second-ten {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			15% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			16.66% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			31.66% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			33.33% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			48.33% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			50% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			65% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			66.66% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			81.66% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			83.33% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			98.33% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			to {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
		}
		
		@-webkit-keyframes second-ten {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			15% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			16.66% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			31.66% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			33.33% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			48.33% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			50% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			65% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			66.66% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			81.66% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			83.33% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			98.33% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			to {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
		}
		
		@keyframes second-ten {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			15% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			16.66% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			31.66% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			33.33% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			48.33% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			50% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			65% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			66.66% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			81.66% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			83.33% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			98.33% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			to {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
		}
		
		@-webkit-keyframes second-ten {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			15% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			16.66% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			31.66% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			33.33% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			48.33% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			50% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			65% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			66.66% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			81.66% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			83.33% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			98.33% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			to {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
		}
		
		@keyframes second-ten {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			15% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			16.66% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			31.66% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			33.33% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			48.33% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			50% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			65% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			66.66% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			81.66% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			83.33% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			98.33% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			to {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
		}
		
		@-webkit-keyframes minute-digit {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			9.833% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			19.833% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			29.833% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			39.833% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			49.833% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			59.833% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			69.833% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			79.833% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			89.833% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			99.833% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@keyframes minute-digit {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			9.833% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			19.833% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			29.833% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			39.833% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			49.833% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			59.833% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			69.833% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			79.833% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			89.833% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			99.833% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@-webkit-keyframes minute-digit {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			9.833% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			19.833% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			29.833% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			39.833% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			49.833% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			59.833% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			69.833% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			79.833% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			89.833% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			99.833% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@keyframes minute-digit {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			9.833% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			19.833% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			29.833% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			39.833% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			49.833% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			59.833% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			69.833% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			79.833% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			89.833% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			99.833% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@-webkit-keyframes minute-digit {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			9.833% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			19.833% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			29.833% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			39.833% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			49.833% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			59.833% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			69.833% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			79.833% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			89.833% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			99.833% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@keyframes minute-digit {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			9.833% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			19.833% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			29.833% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			39.833% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			49.833% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			59.833% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			69.833% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			79.833% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			89.833% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			99.833% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@-webkit-keyframes minute-ten {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			16.638888% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			16.666666% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			33.305555% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			33.333333% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			49.972222% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			50% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			66.638888% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			66.666666% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			83.305555% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			83.333333% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			99.972222% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			to {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
		}
		
		@keyframes minute-ten {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			16.638888% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			16.666666% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			33.305555% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			33.333333% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			49.972222% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			50% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			66.638888% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			66.666666% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			83.305555% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			83.333333% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			99.972222% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			to {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
		}
		
		@-webkit-keyframes minute-ten {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			16.638888% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			16.666666% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			33.305555% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			33.333333% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			49.972222% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			50% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			66.638888% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			66.666666% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			83.305555% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			83.333333% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			99.972222% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			to {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
		}
		
		@keyframes minute-ten {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			16.638888% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			16.666666% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			33.305555% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			33.333333% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			49.972222% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			50% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			66.638888% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			66.666666% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			83.305555% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			83.333333% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			99.972222% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			to {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
		}
		
		@-webkit-keyframes minute-ten {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			16.638888% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			16.666666% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			33.305555% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			33.333333% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			49.972222% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			50% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			66.638888% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			66.666666% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			83.305555% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			83.333333% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			99.972222% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			to {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
		}
		
		@keyframes minute-ten {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			16.638888% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			16.666666% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			33.305555% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			33.333333% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			49.972222% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			50% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			66.638888% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			66.666666% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			83.305555% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			83.333333% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			99.972222% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			to {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
		}
		
		@-webkit-keyframes hour-digit {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			9.9972222% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			19.9972222% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			29.9972222% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			39.9972222% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			49.9972222% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			59.9972222% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			69.9972222% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			79.9972222% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			89.9972222% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			99.9972222% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@keyframes hour-digit {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			9.9972222% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			19.9972222% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			29.9972222% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			39.9972222% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			49.9972222% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			59.9972222% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			69.9972222% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			79.9972222% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			89.9972222% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			99.9972222% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@-webkit-keyframes hour-digit {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			9.9972222% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			19.9972222% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			29.9972222% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			39.9972222% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			49.9972222% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			59.9972222% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			69.9972222% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			79.9972222% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			89.9972222% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			99.9972222% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@keyframes hour-digit {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			9.9972222% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			19.9972222% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			29.9972222% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			39.9972222% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			49.9972222% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			59.9972222% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			69.9972222% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			79.9972222% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			89.9972222% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			99.9972222% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@-webkit-keyframes hour-digit {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			9.9972222% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			19.9972222% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			29.9972222% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			39.9972222% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			49.9972222% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			59.9972222% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			69.9972222% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			79.9972222% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			89.9972222% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			99.9972222% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@keyframes hour-digit {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			9.9972222% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			19.9972222% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			29.9972222% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			39.9972222% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			49.9972222% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			59.9972222% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			69.9972222% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			79.9972222% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			89.9972222% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			99.9972222% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@-webkit-keyframes hour-ten {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			9.99972222% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			19.99972222% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			29.99972222% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			39.99972222% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			49.99972222% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			59.99972222% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			69.99972222% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			79.99972222% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			89.99972222% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			99.99972222% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@keyframes hour-ten {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			9.99972222% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			19.99972222% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			29.99972222% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			39.99972222% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			49.99972222% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			59.99972222% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			69.99972222% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			79.99972222% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			89.99972222% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			99.99972222% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@-webkit-keyframes hour-ten {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			9.99972222% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			19.99972222% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			29.99972222% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			39.99972222% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			49.99972222% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			59.99972222% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			69.99972222% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			79.99972222% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			89.99972222% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			99.99972222% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@keyframes hour-ten {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			9.99972222% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			19.99972222% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			29.99972222% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			39.99972222% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			49.99972222% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			59.99972222% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			69.99972222% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			79.99972222% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			89.99972222% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			99.99972222% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@-webkit-keyframes hour-ten {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			9.99972222% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			19.99972222% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			29.99972222% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			39.99972222% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			49.99972222% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			59.99972222% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			69.99972222% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			79.99972222% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			89.99972222% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			99.99972222% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}
		
		@keyframes hour-ten {
			0% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			9.99972222% {
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}
			10% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			19.99972222% {
				-webkit-transform: translateY(-17px);
				transform: translateY(-17px);
			}
			20% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			29.99972222% {
				-webkit-transform: translateY(-34px);
				transform: translateY(-34px);
			}
			30% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			39.99972222% {
				-webkit-transform: translateY(-51px);
				transform: translateY(-51px);
			}
			40% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			49.99972222% {
				-webkit-transform: translateY(-68px);
				transform: translateY(-68px);
			}
			50% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			59.99972222% {
				-webkit-transform: translateY(-85px);
				transform: translateY(-85px);
			}
			60% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			69.99972222% {
				-webkit-transform: translateY(-102px);
				transform: translateY(-102px);
			}
			70% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			79.99972222% {
				-webkit-transform: translateY(-119px);
				transform: translateY(-119px);
			}
			80% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			89.99972222% {
				-webkit-transform: translateY(-136px);
				transform: translateY(-136px);
			}
			90% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			99.99972222% {
				-webkit-transform: translateY(-153px);
				transform: translateY(-153px);
			}
			to {
				-webkit-transform: translateY(-170px);
				transform: translateY(-170px);
			}
		}.goods-detail .basic-info-wrap .item-block {
	    background: #fff0;
	    padding: 10px 0;
	    position: relative;
	}.goods-detail .basic-info-wrap .item-line dt {
	    display: inline-block;
	    width: 76px;
	    height: 35px;
	    line-height: 35px;
	    text-align: justify;
	    padding-left: 16px;
	    font-size: 12px;
	    margin-right: 16px;
	    color: #838383;
	    flex-shrink: 0;
	}/*! CSS Used from: Embedded */
	p{margin:0;padding:0;}
	i{font-style:normal;}
	*{-webkit-overflow-scrolling:touch;}
	*{box-sizing:border-box;outline:none;}
	p{margin:0;font-weight:400;}
	::-moz-selection{background:#b3d4fc;text-shadow:none;}
	::selection{background:#b3d4fc;text-shadow:none;}
	@media print{
	*,:after,:before{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important;}
	p{orphans:3;widows:3;}
	}
	@media all{
	*,::after,::before{box-sizing:border-box;}
	p{margin-top:0;margin-bottom:1rem;}
	}
	@media print{
	*,::after,::before{text-shadow:none!important;box-shadow:none!important;}
	p{orphans:3;widows:3;}
	}
	@media all{
	*,*:before,*:after{box-sizing:inherit;}
	::-webkit-scrollbar{background-color:rgba(24, 24, 24, 0.07);width:8px;height:8px;}
	::-webkit-scrollbar-thumb{background-color:rgba(24, 24, 24, 0.3);border-radius:6px;-webkit-transition:background 200ms ease;transition:background 200ms ease;}
	::-webkit-scrollbar-thumb:hover{background-color:#34495e;}
	::-webkit-scrollbar-button{display:none;}
	p{margin:0 0 10px;}
	}
	*,::after,::before{box-sizing:border-box;}
	p{margin-top:0;margin-bottom:1rem;}
	::-moz-focus-inner{padding:0;border-style:none;}
	*{margin:0;padding:0;box-sizing:border-box;}
	::-webkit-scrollbar{width:4px;height:4px;}
	::-webkit-scrollbar-track{box-shadow:inset 0 0 4px #a7a7a7;border-radius:30px;}
	::-webkit-scrollbar-thumb{background-color:#a7a7a7;border-radius:10px;}
	::-moz-selection{background:#a7a7a7;color:#fff;}
	::selection{background:#a7a7a7;color:#fff;}
	p{font-family:"Prompt", sans-serif;font-size:16px;font-weight:400;line-height:24px;color:#403c39;}
	@media print{
	*{color:#000000!important;}
	}
	*{-webkit-overflow-scrolling:touch;}
	*{box-sizing:border-box;outline:none;}
	::-moz-selection{background:#b3d4fc;text-shadow:none;}
	::selection{background:#b3d4fc;text-shadow:none;}
	@media print{
	*,:after,:before{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important;}
	}
	/*! CSS Used from: Embedded */
	p{margin:0;padding:0;}
	i{font-style:normal;}
	/*! CSS Used from: Embedded */
	p{margin:0;padding:0;}
	i{font-style:normal;}
	p{margin:0;padding:0;}
	i{font-style:normal;}
	/*! CSS Used from: Embedded */
	p{margin:0;padding:0;}
	i{font-style:normal;}
	p{margin:0;padding:0;}
	i{font-style:normal;}
	/*! CSS Used from: Embedded */
	p{margin:0;padding:0;}
	i{font-style:normal;}
	/*! CSS Used from: Embedded */
	p{margin:0;padding:0;}
	i{font-style:normal;}
	*{-webkit-overflow-scrolling:touch;}
	*{box-sizing:border-box;outline:none;}
	::-moz-selection{background:#b3d4fc;text-shadow:none;}
	::selection{background:#b3d4fc;text-shadow:none;}
	@media print{
	*,:after,:before{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important;}
	}
	*{-webkit-overflow-scrolling:touch;}
	*{box-sizing:border-box;outline:none;}
	::-moz-selection{background:#b3d4fc;text-shadow:none;}
	::selection{background:#b3d4fc;text-shadow:none;}
	@media print{
	*,:after,:before{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important;}
	}
	*,*::before,*::after{box-sizing:border-box;}
	::-moz-focus-inner{padding:0;border-style:none;}
	:focus{outline:initial;}
	*,::after,::before{box-sizing:border-box;}
	::-moz-focus-inner{padding:0;border-style:none;}
	*{margin:0;padding:0;box-sizing:border-box;}
	::-webkit-scrollbar{width:4px;height:4px;}
	::-webkit-scrollbar-track{box-shadow:inset 0 0 4px #a7a7a7;border-radius:30px;}
	::-webkit-scrollbar-thumb{background-color:#a7a7a7;border-radius:10px;}
	::-moz-selection{background:#a7a7a7;color:#fff;}
	::selection{background:#a7a7a7;color:#fff;}
	@media print{
	*{color:#000000!important;}
	}
	@media all{
	*,::after,::before{box-sizing:border-box;}
	}
	@media print{
	*,::after,::before{text-shadow:none!important;box-shadow:none!important;}
	}
	@media all{
	*,*:before,*:after{box-sizing:border-box;}
	}
	@media all{
	*:not(body){-webkit-tap-highlight-color:transparent;-ms-overflow-style:none;scrollbar-width:none;}
	div{border:0;margin:0;padding:0;}
	::-webkit-scrollbar{display:none;}
	::-webkit-scrollbar-button{display:none;}
	::-webkit-scrollbar-track{background:none;}
	::-webkit-scrollbar-thumb{background:#B7B7B7;min-height:40px;border-radius:6px;display:none;}
	:focus{outline:0;}
	}
	@media all{
	*,::after,::before{box-sizing:border-box;}
	}
	@media print{
	*,::after,::before{text-shadow:none!important;box-shadow:none!important;}
	}
	@media all{
	*,*:before,*:after{box-sizing:border-box;}
	}
	@media all{
	*:not(body){-webkit-tap-highlight-color:transparent;-ms-overflow-style:none;scrollbar-width:none;}
	div{border:0;margin:0;padding:0;}
	::-webkit-scrollbar{display:none;}
	::-webkit-scrollbar-button{display:none;}
	::-webkit-scrollbar-track{background:none;}
	::-webkit-scrollbar-thumb{background:#B7B7B7;min-height:40px;border-radius:6px;display:none;}
	:focus{outline:0;}
	}
	@media all{
	*,::after,::before{box-sizing:border-box;}
	}
	@media print{
	*,::after,::before{text-shadow:none!important;box-shadow:none!important;}
	}
	@media all{
	*,*:before,*:after{box-sizing:border-box;}
	}
	@media all{
	*:not(body){-webkit-tap-highlight-color:transparent;-ms-overflow-style:none;scrollbar-width:none;}
	div{border:0;margin:0;padding:0;}
	::-webkit-scrollbar{display:none;}
	::-webkit-scrollbar-button{display:none;}
	::-webkit-scrollbar-track{background:none;}
	::-webkit-scrollbar-thumb{background:#B7B7B7;min-height:40px;border-radius:6px;display:none;}
	:focus{outline:0;}
	}
	@media all{
	*,::after,::before{box-sizing:border-box;}
	}
	@media print{
	*,::after,::before{text-shadow:none!important;box-shadow:none!important;}
	}
	@media screen{
	div{margin:0;padding:0;}
	}
	@media screen{
	div{margin:0;padding:0;}
	}
	@media screen{
	div{margin:0;padding:0;}
	}
	*{padding:0;margin:0;box-sizing:content-box;}
	*{margin:0;padding:0;-webkit-text-size-adjust:none;}
	@media screen{
	div{margin:0;padding:0;}
	}
	@media screen{
	div{margin:0;padding:0;}
	}
	*{padding:0;margin:0;box-sizing:content-box;}
	*{margin:0;padding:0;-webkit-text-size-adjust:none;}
	/*! CSS Used from: Embedded */
	p{margin:0;padding:0;}
	i{font-style:normal;}
	*,*::before,*::after{box-sizing:border-box;}
	::-moz-focus-inner{padding:0;border-style:none;}
	:focus{outline:initial;}
	*,::after,::before{box-sizing:border-box;}
	::-moz-focus-inner{padding:0;border-style:none;}
	*{margin:0;padding:0;box-sizing:border-box;}
	::-webkit-scrollbar{width:4px;height:4px;}
	::-webkit-scrollbar-track{box-shadow:inset 0 0 4px #a7a7a7;border-radius:30px;}
	::-webkit-scrollbar-thumb{background-color:#a7a7a7;border-radius:10px;}
	::-moz-selection{background:#a7a7a7;color:#fff;}
	::selection{background:#a7a7a7;color:#fff;}
	@media print{
	*{color:#000000!important;}
	}
	/*! CSS Used from: Embedded */
	p{margin:0;padding:0;}
	i{font-style:normal;}
	/*! CSS Used from: Embedded */
	p{margin:0;padding:0;}
	i{font-style:normal;}
	/*! CSS Used from: Embedded */
	p{margin:0;padding:0;}
	i{font-style:normal;}
	.count-down span{display:inline-block;width:22px;height:22px;line-height:22px;text-align:center;background:#383838;color:#ffffff;border-radius:2px;}
		.count-down i{color:#ffffff;}
	@media all{
	*,::after,::before{box-sizing:border-box;}
	}
	@media print{
	*,::after,::before{text-shadow:none!important;box-shadow:none!important;}
	}
	@media all{
	*,*:before,*:after{box-sizing:border-box;}
	}
	@media all{
	*:not(body){-webkit-tap-highlight-color:transparent;-ms-overflow-style:none;scrollbar-width:none;}
	div{border:0;margin:0;padding:0;}
	::-webkit-scrollbar{display:none;}
	::-webkit-scrollbar-button{display:none;}
	::-webkit-scrollbar-track{background:none;}
	::-webkit-scrollbar-thumb{background:#B7B7B7;min-height:40px;border-radius:6px;display:none;}
	:focus{outline:0;}
	}
	@media all{
	*,::after,::before{box-sizing:border-box;}
	}
	@media print{
	*,::after,::before{text-shadow:none!important;box-shadow:none!important;}
	}
	@media all{
	*,*:before,*:after{box-sizing:border-box;}
	}
	@media all{
	*:not(body){-webkit-tap-highlight-color:transparent;-ms-overflow-style:none;scrollbar-width:none;}
	div{border:0;margin:0;padding:0;}
	::-webkit-scrollbar{display:none;}
	::-webkit-scrollbar-button{display:none;}
	::-webkit-scrollbar-track{background:none;}
	::-webkit-scrollbar-thumb{background:#B7B7B7;min-height:40px;border-radius:6px;display:none;}
	:focus{outline:0;}
	}
	@media all{
	*,::after,::before{box-sizing:border-box;}
	}
	@media print{
	*,::after,::before{text-shadow:none!important;box-shadow:none!important;}
	}
	@media all{
	*,*:before,*:after{box-sizing:border-box;}
	}
	@media all{
	*:not(body){-webkit-tap-highlight-color:transparent;-ms-overflow-style:none;scrollbar-width:none;}
	div{border:0;margin:0;padding:0;}
	::-webkit-scrollbar{display:none;}
	::-webkit-scrollbar-button{display:none;}
	::-webkit-scrollbar-track{background:none;}
	::-webkit-scrollbar-thumb{background:#B7B7B7;min-height:40px;border-radius:6px;display:none;}
	:focus{outline:0;}
	}
	@media all{
	*,::after,::before{box-sizing:border-box;}
	}
	@media print{
	*,::after,::before{text-shadow:none!important;box-shadow:none!important;}
	}
	@media screen{
	div{margin:0;padding:0;}
	}
	@media screen{
	div{margin:0;padding:0;}
	}
	@media screen{
	div{margin:0;padding:0;}
	}
	*{padding:0;margin:0;box-sizing:content-box;}
	*{margin:0;padding:0;-webkit-text-size-adjust:none;}
	@media screen{
	div,p{margin:0;padding:0;}
	}
	i{font-style:normal;}
	@media screen{
	div,p{margin:0;padding:0;}
	}
	*{padding:0;margin:0;box-sizing:content-box;}
	i{font-style:normal;}
	*{margin:0;padding:0;-webkit-text-size-adjust:none;}
	@media screen{
	div,p{margin:0;padding:0;}
	}
	i{font-style:normal;}
	@media screen{
	div,p{margin:0;padding:0;}
	}
	*{padding:0;margin:0;box-sizing:content-box;}
	i{font-style:normal;}
	*{margin:0;padding:0;-webkit-text-size-adjust:none;}
	.module-20-time span{min-width:22px;height:26px;border:2px solid #fff;border-radius:6px;font-size:14px;font-weight:400;font-weight:initial;background-color:#333;color:#fff;display:inline-block;line-height:28px;text-align:center;padding:0 2px;}
	.module-20-Head .module-20-time{display:inline-block;margin:5px 22px 0px;vertical-align:top;}
	@media (max-width: 1440px){
	.module-20-Head .module-20-time{margin-top:1px;}
	}
	@media screen{
	div{margin:0;padding:0;}
	}
	@media screen{
	div{margin:0;padding:0;}
	}
	*{padding:0;margin:0;box-sizing:content-box;}
	*{margin:0;padding:0;-webkit-text-size-adjust:none;}
	/*! CSS Used fontfaces */
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:100;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:200;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:300;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:500;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:600;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:800;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format("woff2");unicode-range:U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format("woff2");unicode-range:U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format("woff2");unicode-range:U+1F00-1FFF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format("woff2");unicode-range:U+0370-03FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format("woff2");unicode-range:U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format("woff2");unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
	@font-face{font-family:"Prompt";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2");unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
	.module-20-time span {
	    min-width: 22px;
	    height: 26px;
	    border: 1px solid #fff;
	    border-radius: 6px;
	    font-size: 14px;
	    font-weight: 400;
	    font-weight: initial;
	    background-color: #333;
	    color: #fff;
	    display: inline-block;
	    line-height: 28px;
	    text-align: center;
	    padding: 0 2px;
	}.goods-detail .detail-wrap .goods-tab {
	    margin-left: 0px;
	}/*! CSS Used from: https://element-plus.org/assets/style.c017d434.css */
	p{font-size:inherit;}
	p{line-height:1.8;}
	p:first-child{margin-top:0;}
	p:last-child{margin-bottom:0;}
	.el-empty{--el-empty-padding:40px 0;--el-empty-image-width:160px;--el-empty-description-margin-top:20px;--el-empty-bottom-margin-top:20px;--el-empty-fill-color-0:var(--el-color-white);--el-empty-fill-color-1:#fcfcfd;--el-empty-fill-color-2:#f8f9fb;--el-empty-fill-color-3:#f7f8fc;--el-empty-fill-color-4:#eeeff3;--el-empty-fill-color-5:#edeef2;--el-empty-fill-color-6:#e9ebef;--el-empty-fill-color-7:#e5e7e9;--el-empty-fill-color-8:#e0e3e9;--el-empty-fill-color-9:#d5d7de;display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:center;box-sizing:border-box;padding:var(--el-empty-padding);}
	.el-empty__image{width:var(--el-empty-image-width);}
	.el-empty__image svg{color:var(--el-svg-monochrome-grey);fill:currentColor;width:100%;height:100%;vertical-align:top;}
	.el-empty__description{margin-top:var(--el-empty-description-margin-top);}
	.el-empty__description p{margin:0;font-size:var(--el-font-size-base);color:var(--el-text-color-secondary);}
	*,:before,:after{box-sizing:border-box;}
	p{margin:1rem 0;line-height:1.7;}
	*{scrollbar-color:var(--el-scrollbar-bg-color) var(--el-fill-color-light);}
	::-webkit-scrollbar{width:6px;}
	::-webkit-scrollbar-track{border-radius:10px;}
	::-webkit-scrollbar-thumb{background-color:#0003;border-radius:10px;transition:all .2s ease-in-out;}
	::-webkit-scrollbar-thumb:hover{cursor:pointer;background-color:#0000004d;}
	[fill~="none"]{fill:none;}.module-20-time span {
	    min-width: 30px;
	    height: 26px;
	    border: 1px solid #fff;
	    border-radius: 1px;
	    font-size: 14px;
	    font-weight: 500;
	    font-weight: initial;
	    background-color: #333;
	    color: #fff;
	    display: inline-block;
	    line-height: 25.4px;
	    text-align: center;
	    padding: 0 2px;
	}.goods-detail .basic-info-wrap .item-line dt {
    display: inline-block;
    width: 76px;
    height: 35px;
    line-height: 35px;
    text-align: justify;
    padding-left: 16px;
    font-size: 12px;
    margin-right: 16px;
    color: #838383;
    font-weight: 600;
    flex-shrink: 0;
}	tspan { white-space:pre } 
							.t0 { font-size: 20px;fill: #ffffff;font-weight: 700;font-family: "Kanit-Bold", "Kanit" } .count-down span{display:inline-block !important;
	width:22px !important;
	height:22px !important;
	line-height:22px !important;
	text-align:center !important;
	background:#383838 !important;
	color:#ffffff !important;
	border-radius:2px !important; }
	.vjs-icon-volume-high, .video-js .vjs-mute-control .vjs-icon-placeholder {
	    font-family: VideoJS !important;
	 
	}
	.vjs-icon-play, .video-js .vjs-play-control .vjs-icon-placeholder, .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
	    font-family: VideoJS !important;
	
	}.vjs-icon-fullscreen-enter, .video-js .vjs-fullscreen-control .vjs-icon-placeholder {
    font-family: VideoJS!important;

}
</style>
